{
  "#AccessSettings": "Link access",
  "#AddArch": "Add Arch",
  "#AddAttic": "Add Attic",
  "#AddLevel": "Add Level",
  "#AddLowerLevel": "Add Lower Level",
  "#AddMolding": "Add Molding",
  "#AddNewItem": "Add item",
  "#AddPlinths": "Add Plinths",
  "#AddToRoom": "Add to room",
  "#AgentActionCancelled": "Action cancelled",
  "#AgentAnswerTruncated": "(The answer was cut off at the length limit.)",
  "#AgentArchitectDescription": "Walls, rooms, doors and windows.",
  "#AgentArchitectName": "Planner",
  "#AgentBridgeAttempt": "Attempt {0}",
  "#AgentBridgeFailed": "{0}. Run npm run mcp",
  "#AgentBridgeUnavailable": "The bridge server is unavailable",
  "#AgentCheckingSave": "Checking the save",
  "#AgentCommandBusy": "Finish the current edit and try the action again.",
  "#AgentCommandConflict": "The action was not applied: the project has changed.",
  "#AgentCommandDuplicate": "This command number was already used with other parameters.",
  "#AgentCommandFailed": "The action was not completed.",
  "#AgentCommandForbidden": "This tool is not available to the selected agent.",
  "#AgentCommandInvalid": "Invalid command parameters.",
  "#AgentCommandRejected": "The changes were not accepted. Check the save and sync again.",
  "#AgentCommandRevisionConflict": "The project has changed. This action was not applied.",
  "#AgentCommandScopeConflict": "Another project or floor is open. This action was not applied.",
  "#AgentCoordinatorDescription": "Decides which agent gets the task.",
  "#AgentCoordinatorName": "Auto",
  "#AgentCountItemsFew": "{0} items",
  "#AgentCountItemsMany": "{0} items",
  "#AgentCountItemsOne": "{0} item",
  "#AgentCountRoomsFew": "{0} rooms",
  "#AgentCountRoomsMany": "{0} rooms",
  "#AgentCountRoomsOne": "{0} room",
  "#AgentCountWallsFew": "{0} walls",
  "#AgentCountWallsMany": "{0} walls",
  "#AgentCountWallsOne": "{0} wall",
  "#AgentCursorFailed": "Didn't work: {0}",
  "#AgentCursorName": "Agent",
  "#AgentDecoratorDescription": "Furniture, arrangement and materials.",
  "#AgentDecoratorName": "Decorator",
  "#AgentDesignerDescription": "Does everything: layout, furniture, finishes, views and renders.",
  "#AgentDesignerName": "Designer",
  "#AgentDoneArchAdded": "Added an opening: arch",
  "#AgentDoneArrangedAround": "Arranged around: {0}",
  "#AgentDoneCameraAimed": "Camera aimed",
  "#AgentDoneCatalogFound": "Found in the catalog: {0}",
  "#AgentDoneChangeSaved": "Change saved",
  "#AgentDoneDeleted": "Deleted ({0}): {1}",
  "#AgentDoneDoorAdded": "Added an opening: door",
  "#AgentDoneEditorStatus": "Checked the connection to the editor",
  "#AgentDoneFinish": "Finish: {0}",
  "#AgentDoneFloor": "Floor {0}",
  "#AgentDoneFloorCleared": "Floor cleared",
  "#AgentDoneItemAdded": "Added an item: {0}",
  "#AgentDoneItemChanged": "Changed an item: {0}",
  "#AgentDoneItemDuplicated": "Duplicated: {0}",
  "#AgentDoneItemReplaced": "Replaced with {0}",
  "#AgentDoneMaterial": "Material: {0}",
  "#AgentDoneMaterialsFound": "Materials found: {0}",
  "#AgentDoneOpening": "Opening {0}",
  "#AgentDoneOpeningChanged": "Changed opening {0}",
  "#AgentDonePanelOpened": "Opened panel: {0}",
  "#AgentDonePanelsClosed": "Panels closed",
  "#AgentDonePlacedAlongWall": "Placed along the wall: {0}",
  "#AgentDonePlacedBeside": "Placed alongside: {0}",
  "#AgentDonePlanSnapshot": "Plan snapshot",
  "#AgentDoneProjectCreated": "Created project “{0}”",
  "#AgentDoneProjectList": "Project list",
  "#AgentDoneReadScene": "Read the scene",
  "#AgentDoneRedone": "Steps redone: {0}",
  "#AgentDoneRenamed": "Renamed: “{0}”",
  "#AgentDoneRenderReady": "Render ready",
  "#AgentDoneReport": "Report from agent {0}",
  "#AgentDoneReports": "Agent reports: {0}",
  "#AgentDoneReportsFailed": "Agent reports: {0} ({1} failed)",
  "#AgentDoneRoomAdded": "Added room #{0} “{1}”",
  "#AgentDoneRoomChanged": "Changed room #{0}",
  "#AgentDoneRoomFurnishedFew": "Furnished room #{1}: {0} items",
  "#AgentDoneRoomFurnishedMany": "Furnished room #{1}: {0} items",
  "#AgentDoneRoomFurnishedOne": "Furnished room #{1}: {0} item",
  "#AgentDoneSelected": "Selected",
  "#AgentDoneSelectionCleared": "Selection cleared",
  "#AgentDoneUndone": "Steps undone: {0}",
  "#AgentDoneViewSnapshot": "3D view snapshot",
  "#AgentDoneViewSwitched": "View switched",
  "#AgentDoneWallAdded": "Added a wall {0}→{1}",
  "#AgentDoneWallChanged": "Changed wall {0}",
  "#AgentDoneWallsAdded": "Added walls",
  "#AgentDoneWholeFloor": "Showing the whole floor",
  "#AgentDoneWindowAdded": "Added an opening: window",
  "#AgentErrorApiKey": "The API key was not accepted. Check the key in the agent settings.",
  "#AgentErrorBadRequest": "The model rejected the request: {0}",
  "#AgentErrorForbidden": "Access denied: {0}",
  "#AgentErrorNoConnection": "No connection to the model service. Check the network and try again.",
  "#AgentErrorNotConfigured": "The agent is not set up on the server: the agent proxy has no key for this provider. Choose another provider or enter your own key in the agent settings.",
  "#AgentErrorRateLimit": "Too many requests to the model. Wait a little and try again.",
  "#AgentErrorServiceDown": "The model service is temporarily unavailable. Try again in a minute.",
  "#AgentExternalName": "External agent",
  "#AgentHealthAllOk": "Everything the agent relies on responds.",
  "#AgentHealthBots": "Agent bots",
  "#AgentHealthBotsReadyFew": "{0} agents in the project — cursors on the stage, a view opens from an avatar in the header",
  "#AgentHealthBotsReadyMany": "{0} agents in the project — cursors on the stage, a view opens from an avatar in the header",
  "#AgentHealthBotsReadyOne": "{0} agent in the project — cursors on the stage, its view opens from the avatar in the header",
  "#AgentHealthBotsRunning": "Calling the agent bots",
  "#AgentHealthBotsUnavailable": "unavailable: a shared project is open or the editor is not ready",
  "#AgentHealthCatalog": "Model catalog",
  "#AgentHealthCatalogAnswered": "responds in {0}: {1} models in the “{2}” section",
  "#AgentHealthCatalogRunning": "Asking the catalog",
  "#AgentHealthFailedList": "Not working: {0}.",
  "#AgentHealthLocalDown": "the local agent is not responding",
  "#AgentHealthLocalDownDetail": "the local agent is not responding ({0})",
  "#AgentHealthLocalUp": "the local Claude Code agent responds",
  "#AgentHealthLocalUpProject": "the local Claude Code agent responds, project “{0}”",
  "#AgentHealthMaterialsAnswered": "respond in {0}: {1} in the “{2}” section",
  "#AgentHealthMaterialsRunning": "Loading materials",
  "#AgentHealthMockMode": "training mode: answers without a model",
  "#AgentHealthModel": "Model",
  "#AgentHealthModelAnswered": "{0} answered in {1}",
  "#AgentHealthModelAnsweredText": "{0} answered in {1} (“{2}”)",
  "#AgentHealthModelMissing": "not connected — requests go to the simulation",
  "#AgentHealthModelRunning": "Asking the model",
  "#AgentHealthName": "Health check",
  "#AgentHealthNoFrame": "no frame was captured",
  "#AgentHealthNoMaterialSections": "there are no material sections",
  "#AgentHealthNoModelNote": "Without a model the agents answer in simulation mode: they show their work on the project without changing it. Connect a model in the agent settings.",
  "#AgentHealthNoSofas": "the catalog tree has no sofa section",
  "#AgentHealthNoView": "the editor view is not available",
  "#AgentHealthOpenAICompatible": "OpenAI-compatible",
  "#AgentHealthProject": "Reading the project",
  "#AgentHealthProjectCounts": "{0}, {1}, {2} on the floor",
  "#AgentHealthProjectRunning": "Reading the project with the agent's tool",
  "#AgentHealthRequest": "Check that the agent works",
  "#AgentHealthServer": "Agent server",
  "#AgentHealthServerDown": "not responding — no model through the editor's server",
  "#AgentHealthServerKeys": "responding, keys: {0}",
  "#AgentHealthServerNoKey": "responding, but it holds no model key",
  "#AgentHealthServerRunning": "Checking the agent server",
  "#AgentHealthSnapshot": "View snapshot",
  "#AgentHealthSnapshotRunning": "Capturing the current view",
  "#AgentHealthSnapshotTaken": "{0}, {1} KB — the agent sees what you see",
  "#AgentHealthSummary": "Check complete: {0} of {1} working.",
  "#AgentHealthToolSilent": "the tool did not answer",
  "#AgentHealthViewOrbit": "3D orbit",
  "#AgentHealthViewPlan": "plan",
  "#AgentHealthViewWalk": "3D walk",
  "#AgentLocalFailed": "The local agent finished with an error.",
  "#AgentLocalHttpError": "The local agent answered with HTTP error {0}.",
  "#AgentLocalLimit": "The Claude Code subscription limit is used up for this period. Try later or switch the model to sonnet.",
  "#AgentLocalModelDefault": "Claude Code default",
  "#AgentLocalNoOk": "the server answered without ok",
  "#AgentLocalNotLoggedIn": "Claude Code is not signed in. Open claude in a terminal, run /login (sign in with your subscription) and try again.",
  "#AgentLocalNotOnBridge": "the page is not connected to the bridge yet",
  "#AgentLocalNotRunning": "The local agent is not running. Run this in the project folder: npm run agent:local",
  "#AgentLocalStartHint": "run npm run agent:local",
  "#AgentMockDone": "Done (a training answer without a model): I read the scene and applied the changes. Tell me what to adjust.",
  "#AgentMockLooking": "Looking at the scene…",
  "#AgentMockRoomName": "Agent's room",
  "#AgentModelRefused": "The model refused to carry out this request.",
  "#AgentNewChat": "New chat",
  "#AgentNewProjectName": "My design",
  "#AgentOpenProjectFirst": "Open a project — the agent works inside the editor.",
  "#AgentPanelAddAgent": "Add agent",
  "#AgentPanelAgent": "Agent",
  "#AgentPanelAgentChat": "Agent chat",
  "#AgentPanelAgentName": "Agent name",
  "#AgentPanelAgentNamePlaceholder": "Name, e.g. “Lighting”",
  "#AgentPanelAgents": "Agents",
  "#AgentPanelAgentSnapshot": "The snapshot the agent saw",
  "#AgentPanelAgentThinking": "The agent is thinking",
  "#AgentPanelAiAgent": "AI agent",
  "#AgentPanelAllTools": "all tools",
  "#AgentPanelAnthropicKey": "Anthropic API key",
  "#AgentPanelAttachView": "Attach a snapshot of the current view",
  "#AgentPanelBackToChats": "Back to chats",
  "#AgentPanelBridgeConnected": "Bridge connected: the editor's tools are available to external agents.",
  "#AgentPanelBridgeConnecting": "Connecting to the bridge…",
  "#AgentPanelBridgeOffline": "The bridge isn't responding{0}.",
  "#AgentPanelBuiltInModel": "Model for built-in agents",
  "#AgentPanelBuiltInOnly": "Only the built-in ones so far: {0}.",
  "#AgentPanelChatActions": "Actions: {0}",
  "#AgentPanelChatName": "Chat name",
  "#AgentPanelChatsEmpty": "Chats with the agent about this project will gather here.",
  "#AgentPanelCheckingServer": "Checking the server…",
  "#AgentPanelCloseSettings": "Close settings",
  "#AgentPanelCollapseChat": "Collapse chat",
  "#AgentPanelCollapseEsc": "Collapse (Esc)",
  "#AgentPanelCompatibleUrl": "Compatible API address",
  "#AgentPanelCompatibleUrlPlaceholder": "Your own API address (optional), e.g. https://host/api/agent",
  "#AgentPanelCustomAgentDescription": "Custom agent.",
  "#AgentPanelCustomAgents": "Custom agents",
  "#AgentPanelDefaultModel": "Default ({0})",
  "#AgentPanelDeleteAgent": "Delete agent {0}",
  "#AgentPanelDeleteChat": "Delete chat",
  "#AgentPanelEarlier": "Earlier",
  "#AgentPanelEmptyIntro": "{0} — {1} Tell it what to do in the project, or pick an example:",
  "#AgentPanelErrorTime": "Error after {0}",
  "#AgentPanelExternalAgents": "External agents",
  "#AgentPanelExternalText": "Accept commands from Claude Code, Claude Desktop and other MCP clients",
  "#AgentPanelExternalTitle": "External agents (MCP)",
  "#AgentPanelFinishedFailed": "Finished · Failed: {0}",
  "#AgentPanelHealthCheck": "Health check",
  "#AgentPanelInstructions": "Instructions for the agent",
  "#AgentPanelInstructionsPlaceholder": "Who this agent is and how it should work",
  "#AgentPanelLiveDemo": "Live 2D / 3D demo",
  "#AgentPanelLocalAgent": "Local agent",
  "#AgentPanelLocalChecking": "Local agent…",
  "#AgentPanelLocalLogin": "Sign in to Claude Code in a terminal once ({0}, then {1}), then start the server in the project folder:",
  "#AgentPanelLocalModel": "Local agent model",
  "#AgentPanelLocalOffline": "Local agent not running",
  "#AgentPanelLocalReady": "Local agent ready",
  "#AgentPanelLocalServerOffline": "The server isn't responding at {0}{1}.",
  "#AgentPanelLocalServerReady": "The local agent server is responding{0}.",
  "#AgentPanelLocalServerReadyProject": "The local agent server is responding, project “{0}”{1}.",
  "#AgentPanelLocalText": "Run tasks through Claude Code on this computer — on your subscription, without an API key",
  "#AgentPanelLocalTitle": "Local agent (Claude Code subscription)",
  "#AgentPanelLocalUrl": "Local agent address",
  "#AgentPanelMcpConnected": "MCP connected",
  "#AgentPanelMcpConnecting": "MCP: connecting…",
  "#AgentPanelMcpOffline": "MCP: no connection",
  "#AgentPanelMcpRun": "Run {0} in the project folder on this computer and add the server to your client:",
  "#AgentPanelMinutes": "{0}m",
  "#AgentPanelMinutesSeconds": "{0}m {1}s",
  "#AgentPanelMockLabel": "Training mode without a model",
  "#AgentPanelMockText": "Training mode: answer without a model (to check the interface)",
  "#AgentPanelModel": "Model",
  "#AgentPanelModelCheck": "Model: {0}. Try the agents without it:",
  "#AgentPanelModelDefault": "Agent's default",
  "#AgentPanelModelName": "Model name",
  "#AgentPanelModelNamePlaceholder": "Model name, e.g. gpt-5",
  "#AgentPanelNewChat": "New chat",
  "#AgentPanelNoModel": "No model connected.",
  "#AgentPanelNoModelText": "The agents will show their work on your project in simulation mode, without changing it.",
  "#AgentPanelOpenChat": "Open chat",
  "#AgentPanelOtherModel": "Other model…",
  "#AgentPanelOwnKeyText": "Without a key, requests go through the editor server. With your own key, the browser talks to Anthropic directly; the key is stored only in this browser.",
  "#AgentPanelOwnKeyTitle": "Your own API key",
  "#AgentPanelProvider": "Provider",
  "#AgentPanelProviderAuto": "Chosen automatically from the editor server's keys.",
  "#AgentPanelProviderChecking": "Checking which keys the server has…",
  "#AgentPanelProviderKey": "Provider key",
  "#AgentPanelProviderKeyPlaceholder": "Provider key (optional if the server has one)",
  "#AgentPanelProviderModel": "Provider model",
  "#AgentPanelProviderNoKeys": "The editor server has no keys: choose a provider and enter your own key.",
  "#AgentPanelProviderNoServerKey": "The editor server has no key: enter your own (it's stored only in this browser) or set AGENT_OPENAI_API_KEY on the server.",
  "#AgentPanelProviderServerKey": "The editor server has a key for this provider; without your own key, requests go through it.",
  "#AgentPanelProviderServerKeyAt": "The editor server has a key for this provider ({0}); without your own key, requests go through it.",
  "#AgentPanelProviderTitle": "Model provider",
  "#AgentPanelProviderUrl": "Provider API address",
  "#AgentPanelReasoning": "Reasoning",
  "#AgentPanelRemoveSnapshot": "Remove snapshot",
  "#AgentPanelRetry": "Retry",
  "#AgentPanelRollback": "Roll back answer",
  "#AgentPanelRollbackSteps": "Roll back answer ({0})",
  "#AgentPanelRolledBack": "Changes reverted",
  "#AgentPanelRunningOpen": "The agent is working — open the chat",
  "#AgentPanelSeconds": "{0}s",
  "#AgentPanelSendEnter": "Send (Enter)",
  "#AgentPanelSettings": "Agent settings",
  "#AgentPanelShowView": "Show the agent the current view",
  "#AgentPanelSimulate": "Agent simulation",
  "#AgentPanelSimulateLook": "Look at the project",
  "#AgentPanelStampDate": "{0}, {1}",
  "#AgentPanelStampToday": "Today, {0}",
  "#AgentPanelStampYesterday": "Yesterday, {0}",
  "#AgentPanelStepsFew": "{0} steps",
  "#AgentPanelStepsMany": "{0} steps",
  "#AgentPanelStepsOne": "{0} step",
  "#AgentPanelStepsThinking": "{0}, thinking…",
  "#AgentPanelStepsWithFailed": "{0}, {1} failed",
  "#AgentPanelStop": "Stop",
  "#AgentPanelStopAgent": "Stop the agent",
  "#AgentPanelStopped": "Stopped",
  "#AgentPanelStoppedStatus": "Stopped",
  "#AgentPanelStoppedTime": "Stopped after {0}",
  "#AgentPanelSubagentDone": "done",
  "#AgentPanelSubagentFailed": "failed",
  "#AgentPanelSubagentWorking": "working…",
  "#AgentPanelSuggest3D": "Show the result in 3D",
  "#AgentPanelSuggestBedroom": "Build a bedroom and put a bed in it",
  "#AgentPanelSuggestFloor": "Make the floor light oak",
  "#AgentPanelSuggestFurnish": "Furnish the largest room",
  "#AgentPanelSuggestProjects": "What ready-made projects are there?",
  "#AgentPanelSuggestRender": "Make a Scandi-style render",
  "#AgentPanelSuggestRoom": "Create a 5×4 m room with a window",
  "#AgentPanelSuggestWindow": "Add a window to the long wall",
  "#AgentPanelTaskLabel": "Task for the agent",
  "#AgentPanelTaskPlaceholder": "Give it any task",
  "#AgentPanelThinking": "Thinking…",
  "#AgentPanelThinkingModeLabel": "Model thinking mode",
  "#AgentPanelThinkingModeText": "Thinking mode (DeepSeek thinks before every step: more accurate, but several times slower)",
  "#AgentPanelToolsAgents": "Other agents",
  "#AgentPanelToolsBuild": "Walls and openings",
  "#AgentPanelToolsHistory": "Undo",
  "#AgentPanelToolsProject": "Projects",
  "#AgentPanelToolsRead": "Reading the scene",
  "#AgentPanelToolsRender": "Render",
  "#AgentPanelToolsView": "View and panels",
  "#AgentPanelUndoAll": "The whole answer also rolls back in one click.",
  "#AgentPanelUndoEach": "Each action can be undone on its own.",
  "#AgentPanelUrlKey": "Key for this address",
  "#AgentPanelUrlKeyPlaceholder": "Key for this address (optional)",
  "#AgentPanelViewSnapshot": "View snapshot",
  "#AgentPanelWorked": "Worked",
  "#AgentPanelWorkedTime": "Worked {0}",
  "#AgentPanelWorking": "The agent is working…",
  "#AgentPanelWorkingOnRequest": "Working on the request…",
  "#AgentPhotographerDescription": "Framing, camera and AI renders.",
  "#AgentPhotographerName": "Render",
  "#AgentProjectFallbackName": "Project",
  "#AgentProviderClosed": "The provider closed the stream without an answer.",
  "#AgentProviderDown": "The provider's service is temporarily unavailable. Try again in a minute.",
  "#AgentProviderError": "Provider error",
  "#AgentProviderKeyRejected": "The provider did not accept the key. Check the key in the agent settings.",
  "#AgentProviderNoBody": "The provider answered with an empty body.",
  "#AgentProviderNoConnection": "No connection to the provider. Check the API address and the network.",
  "#AgentProviderNoFunds": "The provider account has no funds.",
  "#AgentProviderNoFundsDetail": "The provider account has no funds ({0}).",
  "#AgentProviderNotFound": "The provider could not find the model or the address.",
  "#AgentProviderNotFoundDetail": "The provider could not find the model or the address: {0}.",
  "#AgentProviderOpenAICompatible": "OpenAI-compatible API (DeepSeek, OpenAI…)",
  "#AgentProviderRateLimit": "The provider limited the number of requests. Wait and try again.",
  "#AgentProviderRejected": "The provider rejected the request (HTTP {0}).",
  "#AgentProviderRejectedDetail": "The provider rejected the request (HTTP {0}): {1}.",
  "#AgentRollbackBusy": "Finish the current edit. Nothing was rolled back.",
  "#AgentRollbackChanged": "The project changed after this answer. It was not rolled back, to keep the new changes.",
  "#AgentRollbackChecking": "Checking that the rollback was saved…",
  "#AgentRollbackExternal": "This answer ran through the external bridge. To keep other changes, undo step by step.",
  "#AgentRollbackRename": "Renaming the project is not rolled back with the answer. Undo step by step for changes to the plan.",
  "#AgentRollbackRunning": "Wait for the current answer to finish. Nothing was rolled back.",
  "#AgentSeconds": "{0} s",
  "#AgentSimAccents": "Choosing accent colors for the cushions",
  "#AgentSimAccentsDone": "Accent — terracotta and olive",
  "#AgentSimAnswerCatalog": "- Catalog: {0}.",
  "#AgentSimAnswerCatalogPicked": "- Catalog: picked {0}.",
  "#AgentSimAnswerDecor": "- Decor: {0}.",
  "#AgentSimAnswerFailedSteps": "Steps that failed: {0} — details in the agents' cards.",
  "#AgentSimAnswerFloor": "Done — the agents worked through the floor for the request “{0}”.",
  "#AgentSimAnswerLayout": "- Layout: {0}.",
  "#AgentSimAnswerNamedRoom": "Done — the agents worked through “{0}” for the request “{1}”.",
  "#AgentSimAnswerNote": "This is a simulation: the agents showed their work on your project; the project itself is unchanged. To have them carry out tasks, connect a model in the agent settings.",
  "#AgentSimAnswerRoom": "Done — the agents worked through the {0} m² room for the request “{1}”.",
  "#AgentSimAnswerStyle": "- Style: {0}.",
  "#AgentSimAxis": "Working out the layout axis",
  "#AgentSimAxisCenter": "Axis — through the center of the room",
  "#AgentSimAxisWall": "Axis — along the {0} m wall",
  "#AgentSimCatalogSilent": "the catalog did not answer",
  "#AgentSimChoiceDeferred": "The choice waits for the catalog's answer",
  "#AgentSimChoosingModel": "Choosing a model",
  "#AgentSimCoffeeTable": "Choosing a coffee table",
  "#AgentSimCoffeeTableLater": "I'll pick the coffee table after the layout",
  "#AgentSimCoffeeTablePicked": "Picked the coffee table {0}",
  "#AgentSimCurtainFabric": "Choosing the curtain fabric",
  "#AgentSimCurtainFabricDone": "Curtain fabric — linen, beige",
  "#AgentSimCurtainTone": "Matching the curtain tone to the walls",
  "#AgentSimCurtainToneDone": "Curtain tone — half a shade lighter than the walls",
  "#AgentSimCushions": "Choosing cushions",
  "#AgentSimCushionsDone": "Two cushions on each sofa",
  "#AgentSimCushionsLater": "I'll match the cushions to the sofa",
  "#AgentSimDecorUnfinished": "not finished",
  "#AgentSimDefaultRequest": "Furnish the largest room",
  "#AgentSimFailed": "The simulation stopped: {0}",
  "#AgentSimFinishCustom": "custom image",
  "#AgentSimFinishDefault": "default",
  "#AgentSimFoundModels": "Found {0} models in the “{1}” section",
  "#AgentSimItem": "item",
  "#AgentSimKept": "Kept “{0}”",
  "#AgentSimKeptNoChange": "Kept “{0}” — no replacement needed",
  "#AgentSimLookRequest": "Look at the project",
  "#AgentSimMarkingZones": "Marking out furniture zones",
  "#AgentSimMeasured": "Measured the room: {0} × {1} m, {2} m²",
  "#AgentSimMeasuredNamed": "Measured “{0}”: {1} × {2} m, {3} m²",
  "#AgentSimMeasuring": "Measuring the room",
  "#AgentSimModelBySize": "model {0} × {1} cm",
  "#AgentSimModelTitled": "“{0}” ({1} × {2} cm)",
  "#AgentSimName": "Agents · simulation",
  "#AgentSimNoRooms": "No rooms on the floor — a plan is needed",
  "#AgentSimNoSection": "The catalog tree has no {0} section",
  "#AgentSimOpenProjectFirst": "Open a project — the agents work inside the editor.",
  "#AgentSimPalette": "Analyzing the palette",
  "#AgentSimPaletteDone": "Palette: floor — {0}, walls — {1}",
  "#AgentSimPaletteUnread": "the palette was not read",
  "#AgentSimPicked": "Picked {0}",
  "#AgentSimPickedFrom": "{0} from the “{1}” section",
  "#AgentSimRoomEmpty": "The room is empty — the zones are free",
  "#AgentSimSearchingModels": "Looking for models in the catalog",
  "#AgentSimSectionEmpty": "The “{0}” section is empty for now",
  "#AgentSimStepFailed": "{0}: didn't work",
  "#AgentSimZonesMarked": "Zones marked: {0} in the room",
  "#AgentStepDone": "Done",
  "#AgentStopped": "Stopped.",
  "#AgentToolAddItem": "Placing an item",
  "#AgentToolAddOpening": "Adding an opening",
  "#AgentToolAddRoom": "Building a room",
  "#AgentToolAddWall": "Building a wall",
  "#AgentToolArrangeAround": "Arranging around",
  "#AgentToolCaptureView": "Looking at the scene",
  "#AgentToolClearLevel": "Clearing the floor",
  "#AgentToolDelegate": "Handing off the task",
  "#AgentToolDelete": "Deleting",
  "#AgentToolDuplicateItem": "Duplicating an item",
  "#AgentToolEditorStatus": "Checking the connection",
  "#AgentToolFocus": "Aiming the camera",
  "#AgentToolFurnishRoom": "Furnishing the room",
  "#AgentToolHistory": "Undoing a step",
  "#AgentToolPlaceAlongWall": "Placing along a wall",
  "#AgentToolPlaceBeside": "Placing alongside",
  "#AgentToolProject": "Working with projects",
  "#AgentToolReadScene": "Reading the scene",
  "#AgentToolRenderAi": "Rendering",
  "#AgentToolReplaceItem": "Replacing an item",
  "#AgentToolSearchCatalog": "Searching the catalog",
  "#AgentToolSearchMaterials": "Looking for a material",
  "#AgentToolSelect": "Selecting",
  "#AgentToolSetFloor": "Switching floors",
  "#AgentToolSetMaterial": "Applying a material",
  "#AgentToolSetRoomFinish": "Choosing finishes",
  "#AgentToolSetView": "Switching the view",
  "#AgentToolShowPanel": "Opening a panel",
  "#AgentToolUpdateItem": "Moving an item",
  "#AgentToolUpdateOpening": "Changing an opening",
  "#AgentToolUpdateRoom": "Changing a room",
  "#AgentToolUpdateWall": "Changing a wall",
  "#AiRenderFailedWith": "Render failed: {0}",
  "#AiRenderNoId": "The server returned no render ID",
  "#AiRenderNoImage": "The render finished without an image",
  "#AiRenderNotFound": "Render not found on the server",
  "#AiRenderRejected": "The server rejected the render: HTTP {0}",
  "#AiRenderStatusFailed": "Render status: HTTP {0}",
  "#AiRenderTimeout": "The render is taking longer than {0} min. The server keeps working; the result will appear in the gallery.",
  "#AllFloors": "All Levels",
  "#AllRooms": "All Rooms",
  "#AnyoneCanEdit": "Anyone with the link can edit",
  "#AnyoneCanView": "Anyone with the link can view",
  "#AppAccessClosed": "Access to this project is closed",
  "#AppAskingCatalog": "Asking the catalog about models…",
  "#AppAskOwnerForLink": "Ask the owner to send you a new link.",
  "#AppBackToProjects": "Back to my projects",
  "#AppCollaborationUnavailable": "Collaboration isn't available yet. The service is still being connected.",
  "#AppLoadingModels": "Loading models: {0} of {1}",
  "#AppLocalProjectNotFound": "This local project isn't in this browser.",
  "#ApplyToAllHint_CeilingMolding": "Apply to all ceiling moldings in the room",
  "#ApplyToAllHint_Floor": "Apply to all rooms in the level",
  "#ApplyToAllHint_Plinth": "Apply to all baseboards in the room",
  "#ApplyToAllWithCount": "Apply to all ({0})",
  "#AppModelsPending": "{0} more being prepared: they'll appear when ready",
  "#AppOpenFailed": "Couldn't open project {0}: {1}",
  "#AppOpenFailedTitle": "Couldn't open",
  "#AppProjectFallbackName": "Project",
  "#AppProjectInTrash": "This project is in “Recently Deleted”. Restore it to “My projects” to open it.",
  "#AppRetryConnection": "Retry connection",
  "#AppSharedProjectName": "Shared project",
  "#Area": "Area",
  "#AtticSlopedCeiling": "Sloped ceiling",
  "#Awesome": "Awesome!",
  "#Benefit3dsMax": "3ds Max",
  "#BenefitCatalog": "Catalog",
  "#CameraAiPhoto": "AI Photo",
  "#CameraAiRedesign": "AI Redesign",
  "#CameraAiRenderResult": "AI render result",
  "#CameraAnotherShot": "Another shot",
  "#CameraAskingServer": "Asking the server…",
  "#CameraAskServer": "Ask the server about the render",
  "#CameraAspect": "Aspect ratio",
  "#CameraCapturedShot": "Captured shot",
  "#CameraClose": "Close camera",
  "#CameraCloseGallery": "Close gallery",
  "#CameraCloseViewer": "Close viewer",
  "#CameraDeleteAgainNote": "Once more to delete",
  "#CameraDeleteConfirm": "Click again to delete",
  "#CameraDeleteForever": "Delete permanently?",
  "#CameraElapsedSeconds": "{0} s",
  "#CameraGalleryEmptyHint": "Aim the camera and press the shutter.",
  "#CameraGalleryEmptySubtitle": "Your photos and renders",
  "#CameraGalleryEmptyText": "Your shots and renders will appear here.",
  "#CameraGalleryEmptyTitle": "Save your first shot",
  "#CameraHoldOriginal": "Show the original shot (press and hold)",
  "#CameraItemActions": "Actions: {0} {1}",
  "#CameraLightboxCount": "{0} of {1}",
  "#CameraMinimize": "Minimize",
  "#CameraModeGroup": "Camera mode",
  "#CameraNewShot": "New shot",
  "#CameraNext": "Next",
  "#CameraNextShot": "Next shot",
  "#CameraOpenOriginal": "Open original",
  "#CameraOriginalShot": "Original shot",
  "#CameraPrevious": "Previous",
  "#CameraPreviousShot": "Previous shot",
  "#CameraPrompt": "Notes for the render",
  "#CameraPromptPhotoPlaceholder": "Notes: evening lighting…",
  "#CameraPromptQuoted": "“{0}”",
  "#CameraPromptRedesignPlaceholder": "What to change: more plants, warm light…",
  "#CameraQualityNeedsAccount": "{0} — available with a catalog account",
  "#CameraQualitySide": "{0} — up to {1} px on the long side",
  "#CameraRedesignStyle": "Redesign style",
  "#CameraRenderFailed": "Render failed",
  "#CameraRendering": "Rendering…",
  "#CameraRenderingElapsed": "Rendering… {0}",
  "#CameraRenderingElapsedBusy": "Rendering… {0} · the server is busy, waiting up to 5 minutes",
  "#CameraRenderingShort": "Rendering",
  "#CameraRenderNumber": "No. {0}",
  "#CameraSceneNotReady": "The scene is not ready to shoot yet.",
  "#CameraServerStillRendering": "The server is still rendering",
  "#CameraShoot": "Make a render",
  "#CameraShotCount": "Shots: {0}",
  "#CameraShotFailed": "Couldn't capture the scene.",
  "#CameraShotFailedWith": "Couldn't capture the shot: {0}",
  "#CameraStillRenderingToast": "The server is still rendering. The result will appear in the gallery.",
  "#CameraZoom": "Zoom",
  "#CanEdit": "Editor",
  "#CanView": "Guest",
  "#CanViewDesc": "Can only view the project. Editing is not allowed.",
  "#CatalogApiConversionTimeout": "The conversion didn't finish within 10 minutes",
  "#CatalogApiHttpError": "Catalog: HTTP {0} at {1}",
  "#CatalogDrawerClearSearch": "Clear search",
  "#CatalogDrawerCollapse": "Collapse catalog",
  "#CatalogDrawerFavoritesEmpty": "Star models to collect them here",
  "#CatalogDrawerForgetRecent": "Remove from recent",
  "#CatalogDrawerForgetRecentNamed": "Remove from recent: {0}",
  "#CatalogDrawerGoToCategories": "Go to categories",
  "#CatalogDrawerLoadingModels": "Loading models",
  "#CatalogDrawerLoadingMore": "Loading more models",
  "#CatalogDrawerLoadingSuggestions": "Loading suggestions",
  "#CatalogDrawerMoreFailed": "The next models didn't load",
  "#CatalogDrawerNoAnswer": "The catalog didn't respond",
  "#CatalogDrawerNothingFound": "Nothing found for “{0}”",
  "#CatalogDrawerPopular": "Popular searches",
  "#CatalogDrawerPreparing": "{0} — the first time it is added, the model takes a few seconds to prepare",
  "#CatalogDrawerRecentPopular": "Recent and popular searches",
  "#CatalogDrawerRefine": "Refine",
  "#CatalogDrawerResults": "Search results: {0}",
  "#CatalogDrawerSave": "Add to favorites",
  "#CatalogDrawerSaveNamed": "Add to favorites: {0}",
  "#CatalogDrawerSearch": "Search the catalog",
  "#CatalogDrawerSearchCurtains": "Search curtains",
  "#CatalogDrawerSearchDoor": "Search doors",
  "#CatalogDrawerSearchEverywhere": "Search for “{0}” in the whole catalog",
  "#CatalogDrawerSearchWindow": "Search windows",
  "#CatalogDrawerSectionEmpty": "No models in this section yet",
  "#CatalogDrawerSections": "Catalog sections",
  "#CatalogDrawerSuggestions": "Suggestions",
  "#CatalogDrawerTitle": "Catalog",
  "#CatalogDrawerUnsave": "Remove from favorites",
  "#CatalogDrawerUnsaveNamed": "Remove from favorites: {0}",
  "#CatalogStateModel": "Model",
  "#CatalogStatePicture": "Picture",
  "#CeilingHeight": "Ceiling height",
  "#CeilingPlan2DView": "Ceiling Plan",
  "#ChangeFloorplanScale": "Change plan scale",
  "#ChangeFloorPlanScale": "Change Scale",
  "#ChatAllReactions": "All reactions",
  "#ChatCancelEdit": "Cancel editing",
  "#ChatCancelEsc": "Cancel (Esc)",
  "#ChatCancelReply": "Cancel reply",
  "#ChatClickToRemove": "Click to remove",
  "#ChatCloseChat": "Close chat",
  "#ChatCloseEsc": "Close (Esc)",
  "#ChatComposerLabel": "Message to project participants",
  "#ChatConnectFailed": "Couldn't connect to the chat.",
  "#ChatConnecting": "Connecting to the chat…",
  "#ChatCopyFailed": "Couldn't copy the text",
  "#ChatCopyText": "Copy text",
  "#ChatDeleteText": "The message will disappear for everyone in the chat.",
  "#ChatDeleteTitle": "Delete message?",
  "#ChatDelivered": "Delivered, not read yet",
  "#ChatDemoAmbient1": "I'll look at the bedroom for now — is anyone working on the kitchen?",
  "#ChatDemoAmbient2": "Check out the living room in 3D: I think it got brighter.",
  "#ChatDemoDone1": "Great, looks good!",
  "#ChatDemoDone2": "Super, I'll take a look in a minute.",
  "#ChatDemoFallback1": "Got it 👍",
  "#ChatDemoFallback2": "OK, noted.",
  "#ChatDemoFallback3": "Let's do that.",
  "#ChatDemoFallback4": "Sounds good.",
  "#ChatDemoFinish1": "Light walls look better here.",
  "#ChatDemoFinish2": "Try light oak on the floor — it'll feel warmer.",
  "#ChatDemoFurniture1": "Better turn the sofa toward the window — it's brighter that way.",
  "#ChatDemoFurniture2": "I can pick a couple of options from the catalog.",
  "#ChatDemoHello1": "Hi! 👋",
  "#ChatDemoHello2": "Hi, I'm here — looking at the plan.",
  "#ChatDemoKitchen1": "There's little room by the kitchen window — maybe move the table?",
  "#ChatDemoKitchen2": "I'll look at the kitchen after the living room.",
  "#ChatDemoLaugh1": "😂",
  "#ChatDemoLaugh2": "Yep, that's just how it is 😄",
  "#ChatDemoOpening1": "The window can be wider, the wall allows it.",
  "#ChatDemoOpening2": "The door should rather open into the room.",
  "#ChatDemoQuestion1": "Good question — let me check the project.",
  "#ChatDemoQuestion2": "I think so. Let's check in 3D.",
  "#ChatDemoQuestion3": "We can try: I'll show an option on the plan.",
  "#ChatDemoSeed1": "Hi! The layout is in the project now — we can make the living room brighter.",
  "#ChatDemoSeed2": "Agreed. And the sofa would be better turned toward the window.",
  "#ChatDemoTask1": "OK, I'm on it.",
  "#ChatDemoTask2": "Doing it now.",
  "#ChatDemoThanks1": "You're welcome 🙂",
  "#ChatDemoThanks2": "Anytime!",
  "#ChatDemoView1": "Taking a look in 3D now.",
  "#ChatDemoView2": "I'll make a render once we're done with the furniture.",
  "#ChatDisconnected": "No connection to the chat. New messages will arrive when it's back.",
  "#ChatDismissNotice": "Dismiss",
  "#ChatEdited": "edited",
  "#ChatEditingMessage": "Editing message",
  "#ChatEditPlaceholder": "Edit the message",
  "#ChatEmptyText": "Write to the project's participants: they'll see your message right away, and you'll see who has read it.",
  "#ChatEmptyTitle": "No messages yet",
  "#ChatIntroFineprint": "Collaboration is still being connected to the app's server. To see how it all works, try the example with demo participants.",
  "#ChatIntroText": "Invite people with “Share” — messages, reactions, who has read what and who is typing right now will show up here.",
  "#ChatIntroTitle": "Chat for project participants",
  "#ChatJumpDown": "Down",
  "#ChatJumpToLast": "Jump to the latest message",
  "#ChatJumpToNew": "Jump to new messages: {0}",
  "#ChatLoading": "Loading messages…",
  "#ChatMessage": "Messages",
  "#ChatMessageActions": "Message actions",
  "#ChatMessageDeleted": "Message deleted",
  "#ChatMessageLabelDeleted": "{0}, {1}, message deleted",
  "#ChatMoreMessageActions": "More message actions",
  "#ChatNamesMore": "{0}, {1}, and {2} more",
  "#ChatNamesThree": "{0}, {1}, and {2}",
  "#ChatNamesTwo": "{0} and {1}",
  "#ChatNewCount": "New: {0}",
  "#ChatNewMessages": "New messages",
  "#ChatNotAllSent": "Not everything was sent: no connection to the chat. It will go out as soon as the connection is back.",
  "#ChatNotLoadedText": "They'll appear here as soon as the chat connects.",
  "#ChatNotLoadedTitle": "Messages didn't load",
  "#ChatNotSent": "Not sent",
  "#ChatOnlyYou": "Only you so far",
  "#ChatParticipant": "Participant",
  "#ChatProjectChat": "Project chat",
  "#ChatProjectChatUnread": "Project chat, unread: {0}",
  "#ChatQuoteGone": "Reply to a message that no longer exists",
  "#ChatQuoteLabel": "Reply to a message from {0}: {1}. Show it",
  "#ChatQuoteUnavailable": "Unavailable",
  "#ChatReact": "React",
  "#ChatReactionAdore": "Love it",
  "#ChatReactionAffection": "Affection",
  "#ChatReactionAngry": "Angry",
  "#ChatReactionApplause": "Applause",
  "#ChatReactionAwkward": "Awkward",
  "#ChatReactionCelebration": "Celebration",
  "#ChatReactionChange": "Reaction: {0}. Change",
  "#ChatReactionCool": "Cool",
  "#ChatReactionDeal": "Deal",
  "#ChatReactionFire": "Fire",
  "#ChatReactionHeart": "Heart",
  "#ChatReactionHmm": "Hmm",
  "#ChatReactionHome": "Home",
  "#ChatReactionHooray": "Hooray",
  "#ChatReactionHundred": "Hundred points",
  "#ChatReactionLaugh": "Laugh",
  "#ChatReactionLike": "Like",
  "#ChatReactionLooking": "Looking",
  "#ChatReactionOops": "Oops",
  "#ChatReactionPaint": "Paint",
  "#ChatReactionParty": "Party",
  "#ChatReactionSad": "Sad",
  "#ChatReactionsList": "Reactions: {0}",
  "#ChatReactionSmile": "Smile",
  "#ChatReactionSofa": "Sofa",
  "#ChatReactionSparkle": "Sparkle",
  "#ChatReactionStarStruck": "Star-struck",
  "#ChatReactionStrong": "Strong",
  "#ChatReactionSurprise": "Surprise",
  "#ChatReactionThanks": "Thanks",
  "#ChatReactorOwn": "{0}: {1}. Remove",
  "#ChatReadBy": "Read by {0}",
  "#ChatReplyTo": "Reply to {0}",
  "#ChatRetry": "Retry",
  "#ChatSaveChanges": "Save changes",
  "#ChatSaveEnter": "Save (Enter)",
  "#ChatSendEnter": "Send (Enter)",
  "#ChatSending": "Sending",
  "#ChatShowExample": "Show example",
  "#ChatTypingSeveral": "{0} are typing…",
  "#ChatTypingSingle": "{0} is typing…",
  "#ChatUnavailableText": "The collaboration server doesn't relay messages yet. As soon as it does, the conversation will appear here.",
  "#ChatUnavailableTitle": "The chat isn't connected yet",
  "#ChatWaitingForServer": "Waiting for the collaboration server",
  "#ChatYou": "You",
  "#ChatYouAnd": "You, {0}",
  "#ChooseAnotherImg": "Choose Another Image",
  "#CloneEntireRoom": "Clone entire room",
  "#CloneNightstandHint": "Press button to clone a piece of furniture",
  "#CloneRoomWalls": "Clone walls only",
  "#CollabAllMembers": "All members",
  "#CollabAllMembersUnread": "All members, unread messages: {0}",
  "#CollabAskOwnerForLink": "Ask the owner to send a new link.",
  "#CollabBackToProjects": "Back to my projects",
  "#CollabCheckingInvite": "Checking the invitation…",
  "#CollabCheckingSave": "Checking the save…",
  "#CollabCheckingSaveOffline": "Checking the save. Connect to the internet and sync again.",
  "#CollabClickToFollow": "click to follow their view",
  "#CollabClickToStopFollowing": "click to stop following",
  "#CollabConnectionLost": "Connection lost. Restoring collaboration.",
  "#CollabErrorConflict": "Action not applied: the project has changed. Sync the project and edit again.",
  "#CollabErrorConnect": "Couldn't connect. Check your internet connection and try again.",
  "#CollabErrorDenied": "Access to the project is closed.",
  "#CollabErrorForbidden": "Access to this project is closed. Ask the owner to send a new link.",
  "#CollabErrorInvalidLink": "The link is invalid or has been turned off. Ask the owner for a new link.",
  "#CollabErrorPendingUnreadable": "Couldn't read a pending save. Save a copy before clearing the browser's data.",
  "#CollabErrorRepeat": "Couldn't repeat the request. The original project is saved in this browser.",
  "#CollabErrorStorageBlocked": "The browser doesn't allow saving guest access. Allow this site to store data and try again.",
  "#CollabErrorStorageFull": "Couldn't save data in the browser. Free up space and try again.",
  "#CollabErrorWriteChanges": "Couldn't write the changes in the browser. Free up space or allow storage, then sync again.",
  "#CollabEyebrow": "COLLABORATION",
  "#CollabFinishOrCancelChange": "Finish or cancel the change",
  "#CollabFollowAfterConnecting": "Following is available once connected",
  "#CollabFollowingThisView": "You're following this view",
  "#CollabFollowLoop": "You can't follow each other in a circle",
  "#CollabFollowMemberView": "Follow this member's view",
  "#CollabFollowName": "Follow {0}",
  "#CollabFollowSeeing": "You see what {0} sees",
  "#CollabFollowSwitching": "Switching to the view of {0}",
  "#CollabGuestNote": "Guest access will be saved in this browser. Members with the same name are not merged.",
  "#CollabInProjectNow": "In the project now",
  "#CollabJoining": "Joining…",
  "#CollabJoinLead": "Join to edit the interior together with other members.",
  "#CollabManageAccess": "Manage access",
  "#CollabMemberFallback": "a member",
  "#CollabMemberTab": "{0} · tab {1}",
  "#CollabMemberViewUnavailable": "This member's view isn't available right now",
  "#CollabNamePlaceholder": "How members will see you",
  "#CollabNoConnection": "No connection",
  "#CollabOpeningShared": "Opening the shared project…",
  "#CollabPerfLabel": "Participant performance",
  "#CollabPerfReadout": "{0} fps · frame p95 {1} ms · participants p95 {2} ms · React {3}/s",
  "#CollabPointersLabel": "Members' pointers",
  "#CollabProjectChat": "Project chat",
  "#CollabProjectChatUnread": "Project chat, unread: {0}",
  "#CollabRefreshConnection": "Reconnect",
  "#CollabResponseDelayed": "The response is delayed. Checking the save…",
  "#CollabRetryCheck": "Check again",
  "#CollabSessionChanged": "The collaboration session has changed",
  "#CollabSharedProject": "Shared project",
  "#CollabStatusConflict": "Action not applied: the project has changed",
  "#CollabStatusConnecting": "Connecting…",
  "#CollabStatusDenied": "Access to the project is closed",
  "#CollabStatusOffline": "No connection · editing paused",
  "#CollabStatusPreview": "Preview · changes not applied yet",
  "#CollabStatusReconnecting": "Reconnecting…",
  "#CollabStatusSaved": "All changes saved",
  "#CollabStatusSaving": "Saving…",
  "#CollabStopFollowing": "Stop following",
  "#CollabStopFollowingHint": "Stop following (Esc)",
  "#CollabStopFollowingName": "Stop following {0}",
  "#CollabUnavailable": "Collaboration isn't available yet. The service is still being connected.",
  "#CollabViewUnavailable": "View unavailable right now",
  "#CollabYourName": "Your name",
  "#ColumnsAndBeams": "Columns, beams",
  "#ContextBarCatalogUnavailable": "Catalog unavailable",
  "#ContextBarCatalogUnavailableDetail": "Couldn’t reach the catalog: {0}. Click to try again.",
  "#ContextBarDeleteSelected": "Delete selected",
  "#ContextBarDoneEsc": "Done (Esc)",
  "#ContextBarDragToMove": "Drag to move the toolbar",
  "#ContextBarDuplicateSelected": "Duplicate selected",
  "#ContextBarFieldCm": "{0}, cm",
  "#ContextBarFieldRange": "{0}: from {1} to {2} cm",
  "#ContextBarItemCountFew": "{0} items",
  "#ContextBarItemCountMany": "{0} items",
  "#ContextBarItemCountOne": "{0} item",
  "#ContextBarItemSize": "Item size",
  "#ContextBarMirror": "Mirror",
  "#ContextBarModelConverting": "Converting right now. It will appear by itself in a few seconds.",
  "#ContextBarModelDamaged": "This model is damaged and can’t be shown yet",
  "#ContextBarModelFailed": "Model not prepared",
  "#ContextBarModelFailedRetry": "Couldn’t prepare the model. Please try again",
  "#ContextBarModelMissing": "Model not in the catalog",
  "#ContextBarModelMissingDetail": "The catalog doesn’t know this model: it isn’t on the server. The item stays on the plan as a box.",
  "#ContextBarModelPreparing": "Preparing the model",
  "#ContextBarModelQueued": "Queued to be prepared for the web. It will appear by itself as soon as it is ready.",
  "#ContextBarNoConnection": "no connection",
  "#ContextBarOpeningSize": "Opening size",
  "#ContextBarOpeningSizesCm": "Opening size, cm",
  "#ContextBarRange": "From {0} to {1} cm",
  "#ContextBarResetRotation": "Reset rotation",
  "#ContextBarResetToCatalogSize": "Restore the catalog size",
  "#ContextBarRotate90": "Rotate 90°",
  "#ContextBarSelectionActions": "Actions for the selected object",
  "#ContextBarSelectionShortcuts": "Shortcuts for the selected object",
  "#ContextBarSizesCm": "Size, cm",
  "#ContextCommandsNoRoomForCopy": "There's no room for a copy on the wall nearby.",
  "#ContextCommandsWallTooShortToSplit": "The wall is too short to split.",
  "#CopyLink": "Copy link",
  "#CrmAndSheets": "CRM & spreadsheets",
  "#Curtains": "Curtains",
  "#CurtainsChangeButton": "Choose curtains",
  "#CustomColourHex": "HEX color",
  "#CustomColourHue": "Hue",
  "#CustomColourTitle": "Custom color",
  "#DeleteForever": "Delete Forever",
  "#DeleteItem": "Delete item",
  "#DeleteRoom": "Delete room?",
  "#DemoBotCatalogAgent": "Catalog Agent",
  "#DemoBotCatalogItem": "finding a replacement: {0}",
  "#DemoBotCatalogOrbit": "checking the catalog",
  "#DemoBotCatalogPlan": "finding a spot for furniture",
  "#DemoBotCatalogWalk": "looking at furniture",
  "#DemoBotCheckingOpening": "checking an opening",
  "#DemoBotCheckingWall": "checking a wall",
  "#DemoBotDecorAgent": "Decor Agent",
  "#DemoBotDecorItem": "trying {0}",
  "#DemoBotDecorOrbit": "studying the composition",
  "#DemoBotDecorPlan": "finding a spot for decor",
  "#DemoBotDecorWalk": "arranging decor",
  "#DemoBotItem": "an item",
  "#DemoBotLayoutAgent": "Layout Agent",
  "#DemoBotLayoutItem": "moving {0}",
  "#DemoBotLayoutOrbit": "looking over the floor",
  "#DemoBotLayoutPlan": "checking the layout",
  "#DemoBotLayoutWalk": "walking through the room",
  "#DemoBotPersonItem": "looking at {0}",
  "#DemoBotPersonOrbit": "viewing the project",
  "#DemoBotPersonPlan": "viewing the plan",
  "#DemoBotPersonWalk": "strolling around the room",
  "#DemoBotStyleAgent": "Style Agent",
  "#DemoBotStyleItem": "checking color: {0}",
  "#DemoBotStyleOrbit": "checking the lighting",
  "#DemoBotStylePlan": "checking colors",
  "#DemoBotStyleWalk": "looking at finishes",
  "#DemoControlsClose": "Close simulation",
  "#DemoControlsCrowd": "Number of participants",
  "#DemoControlsDemo": "Demo",
  "#DemoControlsLabel": "Participant simulation",
  "#DemoControlsParticipantsFew": "{0} participants",
  "#DemoControlsParticipantsMany": "{0} participants",
  "#DemoControlsParticipantsOne": "{0} participant",
  "#DemoControlsPauseSimulation": "Pause simulation",
  "#DemoControlsResume": "Resume",
  "#DemoControlsResumeSimulation": "Resume simulation",
  "#DemoControlsSelectionAuto": "All selections",
  "#DemoControlsSelections": "Participants' selections",
  "#DemoControlsViewAuto": "Changing views",
  "#DemoControlsViewFloor": "All in 2D",
  "#DemoControlsViewOrbit": "All in 3D",
  "#DemoControlsViews": "Participants' views",
  "#DemoControlsViewWalk": "Walkthrough",
  "#DemoModeHintDescription1": "See your design full-screen — great for presenting or reviewing.",
  "#DemoModeHintDescription2": "To record, enable screen recording on your device. Demo Mode won’t do it for you.",
  "#DemoModeHintTitle": "Demo Mode",
  "#DemoProjectCoverAlt": "{0}: 3D view of the project",
  "#DemoProjectFloorsFew": "{0} floors",
  "#DemoProjectFloorsMany": "{0} floors",
  "#DemoProjectFloorsOne": "{0} floor",
  "#DemoProjectKitchenLivingName": "Kitchen-living room",
  "#DemoProjectKitchenLivingSummary": "One room, but in detail: a kitchen with built-in appliances, an island, lighting and decor.",
  "#DemoProjectOpen": "Open the ready-made project “{0}”",
  "#DemoProjectRoomsFew": "{0} rooms",
  "#DemoProjectRoomsMany": "{0} rooms",
  "#DemoProjectRoomsOne": "{0} room",
  "#DemoProjectSlowNote": "The first load takes about a minute.",
  "#DemoProjectThreeFloorsName": "Three-story house",
  "#DemoProjectThreeFloorsSummary": "Three different floors with furniture and stairs between them — the largest of the ready-made projects.",
  "#DemoProjectTwoFloorsName": "Two-story house",
  "#DemoProjectTwoFloorsSummary": "A ready house shell: rooms, windows and doors. Both floors have the same layout; furnish it yourself.",
  "#DemoteToGuest": "Demote to Guest",
  "#DoorSlopes": "Door Slopes",
  "#DoorType": "Door Type",
  "#DrawManually": "Draw Manually",
  "#DrawWallHint": "Press here to start drawing the walls",
  "#EditorAddTool": "Add: {0}",
  "#EditorAddToThisWall": "Add to this wall: {0}",
  "#EditorBackToProjects": "Back to projects",
  "#EditorCancelOpening": "Cancel opening",
  "#EditorClear": "Clear",
  "#EditorClearPlan": "Clear plan",
  "#EditorClearPlanQuestion": "Clear the plan?",
  "#EditorClearPlanText": "Walls and items will be removed. You can undo this.",
  "#EditorCloneRoom": "Clone room",
  "#EditorCloneRoomText": "The copy goes next to it, in the nearest free spot, with walls, doors, windows and finishes.",
  "#EditorCloseLighting": "Close lighting",
  "#EditorCloseMessage": "Close message",
  "#EditorCollaborating": "Collaboration",
  "#EditorCornerBottomLeft": "Bottom left corner",
  "#EditorCornerBottomRight": "Bottom right corner",
  "#EditorCornerTopLeft": "Top left corner",
  "#EditorCornerTopRight": "Top right corner",
  "#EditorDeleteFloorQuestion": "Delete {0}?",
  "#EditorDeleteFloorRowLabel": "Delete: {0}",
  "#EditorDeleteFloorText": "Everything on this floor will be deleted.",
  "#EditorDeleteRoom": "Delete room",
  "#EditorDeleteRoomText": "Its walls go, except those shared with neighboring rooms, along with their doors and windows and everything standing or hanging in the room. You can undo this.",
  "#EditorDemo": "Demo",
  "#EditorDemoTooltip": "Demo walkthrough: a full-screen walk",
  "#EditorDrawWalls": "Draw walls",
  "#EditorDuplicateFloorLabel": "Duplicate: {0}",
  "#EditorEdgeBottom": "Bottom, sill",
  "#EditorEdgeLeft": "Left edge",
  "#EditorEdgeRight": "Right edge",
  "#EditorEdgeTop": "Top",
  "#EditorEnterNumber": "Enter a number.",
  "#EditorErrorDetails": "Error details",
  "#EditorExitDemo": "Exit demo",
  "#EditorExportJson": "Export JSON",
  "#EditorExportProject": "Export project",
  "#EditorFinishWalls": "Finish drawing walls",
  "#EditorFinishWallsTooltip": "Finish drawing walls (Esc or right-click ends the chain)",
  "#EditorFitPlan": "Fit plan to view",
  "#EditorFitWall": "Fit wall to view",
  "#EditorFloor": "Floor",
  "#EditorFloorAddedAboveStairs": "“{0}” added above the stairs",
  "#EditorFloorName": "Floor name",
  "#EditorFloorNoticeGo": "Go to floor",
  "#EditorFloorPlanTile": "Floor Plan",
  "#EditorHeightHandleLabel": "Height above floor: drag or press the arrow keys",
  "#EditorHeightHandleValueLabel": "Height above floor {0}: drag or press the arrow keys",
  "#EditorHeightTooltip": "Drag up or down · arrows ±1 cm, with Shift ±10 cm · Enter — position",
  "#EditorHideDemoBots": "Remove agent bots",
  "#EditorHideDimensions": "Hide dimensions",
  "#EditorHideNotice": "Hide",
  "#EditorHintMakePhoto": "Your room is now filled with furniture. Take a realistic photo and share with your family and friends",
  "#EditorHistory": "History",
  "#EditorImportFailed": "Couldn’t read the project.",
  "#EditorImportJson": "Load project JSON",
  "#EditorImportNotProject": "This isn’t a Home Planner Web project file. Choose a JSON saved by exporting a project.",
  "#EditorImportTooLarge": "Choose a project JSON of up to 20 MB.",
  "#EditorItemsLoading": "Loading items",
  "#EditorItemsLoadingProgress": "Loading items",
  "#EditorLoadingEyebrow": "YOUR INTERIOR",
  "#EditorModelLoadingStatus": "Loading 3D models",
  "#EditorModelsFailed": "Couldn’t prepare models: {0}. Select an item to see why",
  "#EditorModelsNotLoaded": "Didn’t load: {0}. The other models are available.",
  "#EditorModelsNotLoadedCount": "Didn’t load: {0}.",
  "#EditorModelsPreparing": "Preparing models: {0} — they’ll appear in the project as they’re ready",
  "#EditorModelsPreparingFailed": "Preparing models: {0}, couldn’t prepare: {1} — they’ll appear in the project as they’re ready",
  "#EditorModeSwitch": "Mode",
  "#EditorNextWall": "Next wall",
  "#EditorNoSceneHint": "Draw walls or a room first: there’s nothing on this floor to show in 3D yet",
  "#EditorOpening": "Opening",
  "#EditorOpeningNoWall": "Doors and windows go into a wall, and there’s no wall nearby this opening fits in.",
  "#EditorOpeningProject": "Opening a space for your ideas…",
  "#EditorOpeningScene": "Opening the scene…",
  "#EditorOpeningToolHint": "Drag onto a wall, or click and pick a spot",
  "#EditorOrbit": "Orbit",
  "#EditorPlanCanvasLabel": "Floor plan: rooms, walls, corners and furniture. Click a room to select it, then drag it or its round handle.",
  "#EditorPlanCanvasTooltip": "Room: click to select, then drag · Alt + drag furniture — copy · Ctrl / ⌘ — no snapping · Shift — move along one axis",
  "#EditorPlanRotationHint": "Drag the round handle around the circle — every floor turns. The plan holds at right angles.",
  "#EditorPlanRotationTitle": "Plan rotation.",
  "#EditorPlanScaleHint": "Click a wall’s length or a room’s area and type the real value.",
  "#EditorPlanScaleTitle": "Plan scale.",
  "#EditorPlanScaleWhat": "What to scale",
  "#EditorPlanSurface": "Plan view",
  "#EditorPreviousWall": "Previous wall",
  "#EditorProjectFallbackName": "Project",
  "#EditorProjectMenu": "Project menu",
  "#EditorProjects": "Projects",
  "#EditorRealRoomArea": "Real room area",
  "#EditorRealWallLength": "Real wall length",
  "#EditorRecenterView": "Center view",
  "#EditorRecognitionCheck": "Check the result.",
  "#EditorRemoveWallQuestion": "Remove the wall?",
  "#EditorRemoveWallText": "A hidden wall stays the room’s boundary: the plan shows it dashed, 3D doesn’t show it. You can undo any action.",
  "#EditorRenameFloorLabel": "Rename: {0}",
  "#EditorResizeHandleLabel": "{0}: drag or press the arrow keys",
  "#EditorResizeHandleSizeLabel": "{0} {1}: drag or press the arrow keys",
  "#EditorResizeHandleTitle": "{0}: drag · arrows ±1 cm, with Shift ±10 cm",
  "#EditorRetryModels": "Retry loading models",
  "#EditorRoomArea": "Room area",
  "#EditorRoomShapeAdding": "Adding…",
  "#EditorRoomShapeLoadFailed": "Couldn’t load the ready-made room. Check your connection and choose it again.",
  "#EditorRoomShapes": "Ready-made room",
  "#EditorRoomShapesBeside": "A ready-made room goes beside the plan, with a door, windows and finishes",
  "#EditorRoomShapesHeading": "A ready-made room with a door, windows and finishes",
  "#EditorRoomShapesShort": "Ready-made",
  "#EditorRoomToolHint": "Drag between two opposite corners",
  "#EditorRotatePlan": "Rotate plan",
  "#EditorRotatePlanHandle": "Rotate plan, now {0}°",
  "#EditorRotatePlanHandleTooltip": "Drag around the circle · arrows ±1°, with Shift ±15°",
  "#EditorRotateTooltip": "Drag to rotate · Enter — 90°",
  "#EditorRulerHint": "Drag across the plan from point to point — the length appears on the line.",
  "#EditorRulerTitle": "Ruler.",
  "#EditorSavedInBrowser": "Saved in this browser",
  "#EditorSaveRetry": "Try again",
  "#EditorSavesInBrowser": "Changes are saved in this browser",
  "#EditorScaleByAreaNote": "The area rescales the whole plan.",
  "#EditorScaleByLengthNote": "The whole plan grows or shrinks by the same amount.",
  "#EditorSceneFps": "Scene FPS",
  "#EditorSceneReady": "Scene ready: {0} items, {1} openings",
  "#EditorSceneReadyPanels": "Scene ready: {0} items, {1} openings, {2} panels",
  "#EditorShareProject": "Share project",
  "#EditorShowCeiling": "Show ceiling",
  "#EditorShowDemoBots": "Show agent bots (example)",
  "#EditorShowDimensions": "Show dimensions",
  "#EditorSillHeight": "From floor",
  "#EditorSillLetter": "from floor",
  "#EditorSizeLetterDepth": "D",
  "#EditorSizeLetterHeight": "H",
  "#EditorSizeLetterWidth": "W",
  "#EditorSizeTypeExactLabel": "{0} {1}, type an exact value",
  "#EditorSizeTypeExactTitle": "{0}: type an exact value",
  "#EditorStatsHud": "{0} FPS · {1}/{2} items",
  "#EditorThisFloor": "This level",
  "#EditorUnsavedChanges": "Unsaved changes",
  "#EditorWalk": "Walkthrough",
  "#EditorWalkStickHint": "Drag around the circle to walk. One finger on the picture looks around, two fingers step and zoom, a double tap walks up to a spot.",
  "#EditorWalkStickLabel": "Walk: drag toward where you want to step",
  "#EditorWallItemNoWall": "This hangs on a wall, and there’s no wall nearby it fits on.",
  "#EditorWallModeLabel": "Walls: {0}",
  "#EditorWallNumber": "Wall {0}",
  "#EditorWallOpeningsToolbar": "Openings in the wall",
  "#EditorWallPlanNeedsRoom": "Draw a room first: the wall plan shows a wall with the room behind it",
  "#EditorWallPlanStepper": "Wall on the plan",
  "#EditorWindowView": "Window view",
  "#EditRoomHintTitle": "Open floor plan to set room shape and size",
  "#EnterRoom": "Enter Room",
  "#ExportFloorplan": "Export Floor Plan",
  "#ExportPDF": "Export PDF",
  "#ExteriorPerimeter": "Exterior perimeter",
  "#ExternalDimensions": "External dimensions",
  "#FailedRenderButtonText": "Try again",
  "#Floor0": "Ground floor",
  "#Floor1": "First floor",
  "#Floor2": "Second floor",
  "#Floor3": "Third floor",
  "#Floor4": "Fourth floor",
  "#Floor5": "Fifth floor",
  "#Floor6": "Sixth floor",
  "#FloorPlan2DView": "Floor Plan",
  "#FloorPlanAbandonedRow": "Floor {0} — stopped",
  "#FloorPlanImportRetry": "Try again",
  "#FloorPlanImportTimeout": "We couldn't recognize the plan. Try again or upload a different photo.",
  "#FloorPlanNotRecognizedRow": "Floor {0} — plan not recognized",
  "#FloorPlanNotStartedRow": "Floor {0} — never started",
  "#FloorPlanReadyRow": "Floor {0} — ready",
  "#FloorPlanScaleNotMatchedRow": "Floor {0} — scale not matched",
  "#FloorPlanTimedOutRow": "Floor {0} — recognition timed out",
  "#FolderDaysLeftFew": "{0} days left",
  "#FolderDaysLeftMany": "{0} days left",
  "#FolderDaysLeftOne": "{0} day left",
  "#FolderLessThanDayLeft": "Less than a day left",
  "#FolderRecentlyDeleted": "Recently Deleted",
  "#Furnish3DHintTitle": "Go to 3D to add furniture and curtains",
  "#GeometryCheckOpeningSize": "Check the opening's size.",
  "#GeometryCheckSizes": "Check the sizes.",
  "#GeometryCheckWallSize": "Check the wall's thickness and height.",
  "#GeometryConnectionTargetGone": "The point to connect to no longer exists.",
  "#GeometryCornerBreaksRoom": "This corner crosses or collapses a room.",
  "#GeometryCornerMergeBlocked": "Can't merge the corner: the wall that would disappear has an opening or an item on it.",
  "#GeometryDrawLongerWall": "Draw a wall at least 20 cm long.",
  "#GeometryEnterFiniteRoomPosition": "Enter finite room coordinates.",
  "#GeometryEnterFiniteSizes": "Enter finite numeric sizes.",
  "#GeometryEnterValidTextureScale": "Enter a valid texture scale.",
  "#GeometryEnterValidTextureTransform": "Enter a valid texture transform.",
  "#GeometryItemNotFound": "Item not found.",
  "#GeometryJunctionLeavesShortWall": "A wall shorter than 20 cm would be left at the joint.",
  "#GeometryJunctionPointUndeletable": "A point where three or more walls meet can't be deleted.",
  "#GeometryMoveBreaksRoom": "This move crosses or collapses a room.",
  "#GeometryMoveBreaksRoomOutline": "This move breaks the room's outline.",
  "#GeometryMoveCollapsesAllRooms": "This move collapses all the rooms.",
  "#GeometryMoveCollapsesRoom": "This move collapses a room.",
  "#GeometryNewWallThroughOpening": "The new wall runs through an opening.",
  "#GeometryNoPlaceForPoint": "There's no place to add a point.",
  "#GeometryOpeningDoesNotFit": "The opening doesn't fit in the wall.",
  "#GeometryOpeningNotFound": "Opening not found.",
  "#GeometryOpeningOrphan": "The opening has lost its wall.",
  "#GeometryOpeningPastWallEnd": "The opening goes past the end of the wall.",
  "#GeometryOpeningsOverlap": "Openings can't overlap.",
  "#GeometryRoomCopyNotClosed": "The room's copy didn't close.",
  "#GeometryRoomEnclosed": "Other rooms surround this one on all sides, and its walls stay theirs. Delete the wall between it and a neighbor to make them one room.",
  "#GeometryRoomNoClosedContour": "The room has no closed outline of walls.",
  "#GeometryRoomNotFound": "Room not found.",
  "#GeometryShapeHasNoRoom": "This shape has no room.",
  "#GeometryWallAlreadyHere": "There's already a wall here.",
  "#GeometryWallEndsCantConnect": "The wall's ends can't connect without changing its length.",
  "#GeometryWallNotFound": "Wall not found.",
  "#GeometryWallsCross": "Walls can't cross without a shared corner.",
  "#GeometryWallSegmentGone": "This part of the wall no longer exists.",
  "#GeometryWallsOverlap": "Walls can't overlap each other.",
  "#GeometryWallTooShort": "A wall must be at least 20 cm long.",
  "#GotIt": "Got It",
  "#GoTo2D": "Go to 2D",
  "#GoTo3D": "Go to 3D",
  "#GroundSurfaceWithInteriorwalls": "Ground surface with interior walls",
  "#GroundSurfaceWithoutWalls": "Ground surface without walls",
  "#GroundSurfaceWithWalls": "Ground surface with walls",
  "#HelpAndFeedback": "Help and Feedback",
  "#HideWall": "Hide wall",
  "#HomeAccountCard": "Home Planner account",
  "#HomeAccountHeadline": "Ideas start with you",
  "#HomeAccountProjectsText": "Come back to them from this device. For a backup, use export in the editor.",
  "#HomeAccountProjectsTitle": "Your projects at hand",
  "#HomeAccountText": "Create interiors and save shots. Right now you're working as a guest: projects and the gallery are kept in this browser.",
  "#HomeAccountTitle": "Your Home Planner",
  "#HomeAllProjects": "All projects",
  "#HomeAutosaveCaption": "Changes are saved automatically.",
  "#HomeBlankSheet": "Blank slate",
  "#HomeBrandLabel": "Home Planner — home",
  "#HomeBrandTagline": "A SPACE FOR IDEAS",
  "#HomeChooseRoomType": "Select room type",
  "#HomeClearSearch": "Clear search",
  "#HomeContinueAsGuest": "Continue as guest",
  "#HomeContinueWorking": "Continue working",
  "#HomeCopying": "Making a copy…",
  "#HomeCopyOriginal": "Make a copy of the original project",
  "#HomeCountInBrowser": "{0} in this browser",
  "#HomeCountInFolder": "{0} in “{1}”",
  "#HomeCover3D": "3D view",
  "#HomeCoverNew": "New design",
  "#HomeCoverWalk": "Walk",
  "#HomeCreateFirstProject": "Create your first project",
  "#HomeCreateProject": "Create project",
  "#HomeCreating": "Creating…",
  "#HomeDeleteForeverOneText": "“{0}” will be deleted with no way to restore it. Saved photos stay in the gallery.",
  "#HomeDeleteForeverSeveralText": "{0} will be deleted with no way to restore them. Saved photos stay in the gallery.",
  "#HomeDeleteOneText": "“{0}” will stay in “Recently Deleted” for {1} days — you can restore it from there. Saved photos stay in the gallery.",
  "#HomeDeleteProject": "Delete the project?",
  "#HomeDeleteProjectForever": "Delete the project forever?",
  "#HomeDeleteSelected": "Delete the selected projects?",
  "#HomeDeleteSelectedForever": "Delete the selected projects forever?",
  "#HomeDeleteSeveralText": "{0} will stay in “Recently Deleted” for {1} days — you can restore them from there. Saved photos stay in the gallery.",
  "#HomeDropHint": "The walls, rooms, doors and windows will appear on their own",
  "#HomeDropToRecognize": "Drop to recognize the plan",
  "#HomeEmptyCaption": "Draw the room's walls, then add furniture and materials.",
  "#HomeFindInspiration": "Find inspiration",
  "#HomeFindProject": "Find a project",
  "#HomeFinishSelecting": "Done selecting",
  "#HomeFirstStep": "The first step to your home",
  "#HomeFirstStepText": "Draw a plan, arrange the furniture and see your interior in 3D.",
  "#HomeFolderCurrent": "Current",
  "#HomeFolderEmpty": "This folder is empty",
  "#HomeFolderEmptyText": "A project gets here through “{0}” in its card's menu.",
  "#HomeFooterTagline": "Designed by you. Made for living.",
  "#HomeGalleryAllProjects": "All projects",
  "#HomeGalleryAllShots": "All shots",
  "#HomeGalleryEmptyText": "Take a photo in the 3D editor and it will appear here. All your photos and renders are gathered in one gallery.",
  "#HomeGalleryEmptyTitle": "Your interior. The best angle.",
  "#HomeGalleryFailed": "Failed",
  "#HomeGalleryGoToProjects": "Go to projects",
  "#HomeGalleryImageFailed": "Couldn't create the image.",
  "#HomeGalleryImagePending": "The image is still being prepared. Go back to the project to check the result.",
  "#HomeGalleryImageUnavailable": "Image unavailable.",
  "#HomeGalleryKindLabel": "Image type",
  "#HomeGalleryLoading": "Opening the gallery…",
  "#HomeGalleryNoMatches": "No shots match these filters",
  "#HomeGalleryNoMatchesText": "Choose another project or image type.",
  "#HomeGalleryOpenOriginal": "Open original",
  "#HomeGalleryOpenProject": "Open project",
  "#HomeGalleryPhoto": "Photo",
  "#HomeGalleryPhotoAlt": "Interior photo",
  "#HomeGalleryPhotos": "Photos",
  "#HomeGalleryPreparing": "Preparing…",
  "#HomeGalleryPreviewAlt": "Interior shot preview",
  "#HomeGalleryProjectFallback": "Project {0}",
  "#HomeGalleryProjectLabel": "Project in the gallery",
  "#HomeGalleryRender": "Render",
  "#HomeGalleryRenderAlt": "Interior render",
  "#HomeGalleryRenders": "Renders",
  "#HomeGalleryResetFilters": "Reset filters",
  "#HomeGalleryRestoreAndOpen": "Restore and open",
  "#HomeGuestProfile": "Guest profile",
  "#HomeGuestProfileSignIn": "Guest profile — sign in to your account",
  "#HomeHeadline": "Where a home begins",
  "#HomeHeroAlt": "A bright living room with natural materials and soft furniture",
  "#HomeHeroCaption": "Organic modern · Home Planner",
  "#HomeHeroEyebrow": "INSPIRATION NEARBY",
  "#HomeHeroText": "Find a style that feels like you.{0}And make it your own.",
  "#HomeHeroTitle": "A home begins{0}with a feeling.",
  "#HomeIdeaFeed": "Idea feed",
  "#HomeIdeasHint": "A selection of Home Planner styles",
  "#HomeIdeasTitle": "Ideas for your home",
  "#HomeImageFailed": "The image didn't load",
  "#HomeImageRetry": "Try again",
  "#HomeLinkBannerText": "Open a project from a shared link and continue in the browser.",
  "#HomeLinkBannerTitle": "Already started in Home Planner?",
  "#HomeLinkField": "Link from Home Planner",
  "#HomeLocalNoteText": "Projects and photos are saved{0}in this browser.",
  "#HomeLocalNoteTitle": "Your personal space",
  "#HomeMainNavigation": "Main navigation",
  "#HomeMakeLocalCopy": "Make a local copy",
  "#HomeMoveButton": "Move",
  "#HomeMoveToFolder": "Move to folder",
  "#HomeMyProjects": "My projects",
  "#HomeNewCardHint": "Room for your next idea",
  "#HomeNewProject": "New project",
  "#HomeNewProjectName": "My design {0}",
  "#HomeNoProjectFound": "No project found",
  "#HomeNoProjectFoundHint": "Try another name or clear the search.",
  "#HomeOpenByLink": "Open from link",
  "#HomeOpenProject": "Open {0}",
  "#HomePasteProjectLink": "Paste a link to a Home Planner project.",
  "#HomePlanBannerText": "Upload a photo or picture of the plan — the walls, rooms, doors and windows appear on their own, and the project opens in 3D.",
  "#HomePlanBannerTitle": "Have an apartment floor plan?",
  "#HomeProjectActions": "Actions for {0}",
  "#HomeProjectCountFew": "{0} projects",
  "#HomeProjectCountMany": "{0} projects",
  "#HomeProjectCountOne": "{0} project",
  "#HomeProjectFolders": "Project folders",
  "#HomeProjectMovedTo": "Project moved to “{0}”",
  "#HomeProjectName": "Project name",
  "#HomeProjectRestoredTo": "Project restored to “{0}”",
  "#HomeProjectsMovedTo": "Projects moved to “{0}”",
  "#HomeProjectsRestored": "Projects restored",
  "#HomeReadProjectsFailed": "Couldn't read the projects in this browser.",
  "#HomeReadyProjects": "Ready-made projects",
  "#HomeReadyProjectsHint": "Open an example and try the editor — nothing to set up",
  "#HomeReadyProjectsOwn": "Home Planner examples — open and edit them like your own",
  "#HomeRestoreOrDeleteProject": "Restore or delete {0}",
  "#HomeRoomShapeFailed": "Couldn't load the room shape. Check your connection and try again.",
  "#HomeSaveFailed": "Couldn't save the changes. Check free space and access to browser storage.",
  "#HomeSearchProjects": "Search projects",
  "#HomeSelectedCount": "Selected: {0}",
  "#HomeSelectedProjects": "Selected projects",
  "#HomeSelectProject": "Select {0}",
  "#HomeSelectProjects": "Select projects",
  "#HomeShapeCaption": "A room with a door, windows, finishes and a light; you can change its shape and size later.",
  "#HomeShapeFromScratch": "From scratch",
  "#HomeShapeFromScratchHint": "Draw the walls from scratch",
  "#HomeSharedNotManaged": "A shared project can't be deleted or moved from here",
  "#HomeSharedProject": "Shared project",
  "#HomeSignedIn": "Signed in",
  "#HomeSignedInText": "You're signed in to your Home Planner account. Projects and the gallery are still kept in this browser.",
  "#HomeSignInFailed": "Couldn't sign in. Try again.",
  "#HomeSignInNote": "The sign-in service will open. Moving and syncing local projects isn't connected yet.",
  "#HomeSignInToAccount": "Sign in to your account",
  "#HomeSkipToContent": "Skip to content",
  "#HomeSortArea": "By area",
  "#HomeSortName": "By name",
  "#HomeSortProjects": "Sort projects",
  "#HomeSortRecent": "Recent first",
  "#HomeStartFromLink": "Start from a project link",
  "#HomeStartFromPlan": "Start from an apartment plan: a photo or picture",
  "#HomeSubtitleFeed": "Find the details your interior will be made of.",
  "#HomeSubtitleGallery": "Photos and renders of your interiors in one place.",
  "#HomeSubtitleHome": "Create interiors you'll love living in.",
  "#HomeSubtitleProjects": "From the first idea to the last detail — it's all here.",
  "#HomeTab": "Home",
  "#HomeTrashCount": "{0} · kept for {1} days, then deleted forever",
  "#HomeTrashedText": "{0} until it's deleted forever. Restore the project to open it again.",
  "#HomeTrashEmpty": "Nothing here",
  "#HomeTrashEmptyText": "Deleted projects are kept here for {0} days — you can restore them during that time.",
  "#HomeViewGrid": "Grid",
  "#HomeViewList": "List",
  "#HomeWholeFeed": "All ideas",
  "#HomeYourSpace": "Your space",
  "#InspirationAllStyles": "All styles",
  "#InspirationBedroomText": "Soft light and a comfortable layout make the bedroom a place to rest. Leave walkways on both sides of the bed and add a separate reading light.",
  "#InspirationBedroomTitle": "A quiet place of your own",
  "#InspirationContemporaryText": "Clean lines, soft furniture and accents that set the character. Start by placing the large pieces and check how easy it is to walk between them.",
  "#InspirationContemporaryTitle": "Contemporary rhythm",
  "#InspirationCreateOwn": "Create your own interior",
  "#InspirationEmptyText": "Try another style or see all ideas.",
  "#InspirationEmptyTitle": "No such collection yet",
  "#InspirationIllustrationNote": "A style illustration from the Home Planner catalog. Create your own project from scratch.",
  "#InspirationImageAlt": "{0}: interior",
  "#InspirationMidCenturyText": "Warm wood, bold geometry and furniture on slim legs. Pair a calm base with one rich color and repeat it in the details.",
  "#InspirationMidCenturyTitle": "Timeless character",
  "#InspirationOrganicText": "Soft silhouettes, wood and natural tones. Leave more free space around the sofa, and layer warm light at several levels.",
  "#InspirationOrganicTitle": "Closer to nature",
  "#InspirationPicks": "Home Planner picks",
  "#InspirationPicksDetail": "— materials and styles from our catalog",
  "#InspirationStyleLabel": "Interior style",
  "#InspirationStyleOrganicModern": "Organic Modern",
  "#InspirationWabiSabiText": "A calm palette and expressive natural textures. Build the interior around a few pieces: a soft sofa, a simple lamp and textiles with a visible weave.",
  "#InspirationWabiSabiTitle": "The beauty of simple things",
  "#InteriorStyleAfricanName": "African",
  "#InteriorStyleArabicName": "Arabic",
  "#InteriorStyleArtDecoName": "Art Deco",
  "#InteriorStyleAsianContemporaryName": "Asian",
  "#InteriorStyleBarbieName": "Barbie",
  "#InteriorStyleBauhausName": "Bauhaus",
  "#InteriorStyleBohoName": "Boho Chic",
  "#InteriorStyleBrutalismName": "Brutalism",
  "#InteriorStyleChaletName": "Chalet",
  "#InteriorStyleCoastalName": "Coastal",
  "#InteriorStyleContemporaryClassicalName": "Contemporary Classic",
  "#InteriorStyleContemporaryName": "Contemporary",
  "#InteriorStyleCountryStyleName": "Country",
  "#InteriorStyleCraftsmanName": "Craftsman",
  "#InteriorStyleEclecticName": "Eclectic",
  "#InteriorStyleEnglishName": "English",
  "#InteriorStyleFarmhouseName": "Farmhouse",
  "#InteriorStyleFrenchCountryProvenceName": "French Country",
  "#InteriorStyleGlamName": "Glam",
  "#InteriorStyleGreekName": "Greek",
  "#InteriorStyleIndianName": "Indian",
  "#InteriorStyleIndustrialName": "Industrial",
  "#InteriorStyleJapandiName": "Japandi",
  "#InteriorStyleMaximalismName": "Maximalism",
  "#InteriorStyleMediterraneanName": "Mediterranean",
  "#InteriorStyleMemphisName": "Memphis",
  "#InteriorStyleMidcenturyName": "Mid-Century Modern",
  "#InteriorStyleMinimalistName": "Minimalist",
  "#InteriorStyleNeoclassicName": "Neoclassical",
  "#InteriorStyleOrganicModernName": "Organic Modern",
  "#InteriorStyleQuietLuxuryName": "Quiet Luxury",
  "#InteriorStyleRetro1970sName": "Retro 70s",
  "#InteriorStyleRetrofuturisticName": "Retro-Futurism",
  "#InteriorStyleRusticName": "Rustic",
  "#InteriorStyleScandinavianName": "Scandinavian",
  "#InteriorStyleShabbyChicName": "Shabby Chic",
  "#InteriorStyleSouthwesternName": "Southwestern",
  "#InteriorStyleSpanishRevivalName": "Spanish Revival",
  "#InteriorStyleTraditionalName": "Traditional",
  "#InteriorStyleTropicalName": "Tropical",
  "#InteriorStyleVictorianName": "Victorian",
  "#InteriorStyleVintageName": "Vintage",
  "#InteriorStyleWabiSabiName": "Wabisabi",
  "#InternetConnectionUnstable": "Your internet connection is unstable",
  "#InviteNormal": "Invite",
  "#InviteProjectUnreadable": "This project's file cannot be read. Let the owner know.",
  "#ItemPropsBadBaseScale": "Couldn't resize: the item's original scale is invalid.",
  "#ItemPropsCantApplySize": "Couldn't apply this size to the item.",
  "#ItemPropsCheckPosition": "Check the item's position.",
  "#ItemPropsSizeMustBePositive": "The item's dimensions must be greater than zero.",
  "#LabelsAndAnnotations": "Labels and annotations",
  "#LeaveProject": "Leave project",
  "#LeaveProjectConfirm": "You will lose access to the project and won't be able to enter it.",
  "#LeaveTeamWriteSupport": "Write to support",
  "#LibraryCopyName": "{0} · copy",
  "#LibraryDefaultName": "My design",
  "#LibraryGalleryReadFailed": "Couldn't read the gallery. Check access to browser storage and reload the page.",
  "#LibraryProjectNotFound": "Project not found.",
  "#LinkUnavailable": "This project can no longer be accessed.",
  "#LinkUnavailableTitle": "Project is no longer available",
  "#LivingArea": "Living area",
  "#LoadingText": "Loading",
  "#LowerLevel": "Lower Level {0}",
  "#MainDimensions": "Main dimensions",
  "#MakePhoto": "Take a Photo",
  "#MaterialContextFromProject": "From the project",
  "#MaterialContextProjectMaterial": "Project material",
  "#MaterialPickerApplied": "Applied: {0}",
  "#MaterialPickerApplyAll": "To all ({0})",
  "#MaterialPickerApplyFailed": "Couldn't get the material. Click it again.",
  "#MaterialPickerApplyToRoomWalls": "Apply to all walls of the room",
  "#MaterialPickerCatalogFailed": "Couldn't load materials from the catalog.",
  "#MaterialPickerCategoryEmpty": "No materials in this category yet.",
  "#MaterialPickerClose": "Close materials",
  "#MaterialPickerFieldCm": "{0}, cm",
  "#MaterialPickerFieldValue": "{0}, value",
  "#MaterialPickerLoadFailed": "Couldn't load materials.",
  "#MaterialPickerLoading": "Loading materials…",
  "#MaterialPickerModelColour": "Model color",
  "#MaterialPickerModelPart": "Model part",
  "#MaterialPickerNotPreparedLabel": "{0}, not prepared yet",
  "#MaterialPickerNotPreparedTitle": "{0} · not prepared yet",
  "#MaterialPickerRecentEmpty": "Materials you choose will appear here.",
  "#MaterialPickerScaleRotation": "Scale and rotation",
  "#MaterialPickerShowMore": "Show more",
  "#MaterialPickerTextureRotation": "Texture rotation",
  "#MaterialPickerTileHeight": "Tile height",
  "#MaterialPickerTileLength": "Tile length",
  "#MaterialPickerTileSize": "Tile size",
  "#MaterialPickerTileWidth": "Tile width",
  "#MaterialPickerWholeDoor": "Whole door",
  "#MaterialPickerWholeItem": "Whole item",
  "#MaterialPickerWholeOpening": "Whole opening",
  "#MaterialPickerWholeWindow": "Whole window",
  "#MaterialsDefinitionHttpError": "Material description: HTTP {0}",
  "#MaterialsNotPrepared": "This material isn't prepared for the web editor yet.",
  "#Message": "Message",
  "#Minimap": "Minimap",
  "#MinimapChooseFloor": "Choose another floor.",
  "#MinimapClose": "Close minimap",
  "#MinimapFloorPlan": "Floor plan",
  "#MinimapHideOthers": "Hide other rooms",
  "#MinimapHint": "Click a room to go there.",
  "#MinimapNoRooms": "There are no rooms on this floor.",
  "#ModelVariationsGlossBlack": "Gloss black",
  "#ModelVariationsVariant": "Variant {0}",
  "#ModelVariationsWalnut": "Walnut",
  "#ModelVariationsWhiteBlack": "White-black",
  "#MoveWallHint": "Move wall to resize the room",
  "#NoCurtains": "No Curtains",
  "#NoFinishWall": "Without finish",
  "#OnlyInvitedPeople": "Only invited people",
  "#OpeningPropsCheckWidth": "Check the opening's width.",
  "#OpeningPropsChooseSashForOpening": "Choose a sash type to open it.",
  "#OpeningPropsCurtainsWindowsOnly": "Curtains are available for windows only.",
  "#OpeningPropsNoRoomToResize": "There's no room on the wall to change the width.",
  "#OpeningPropsOpenAngleRange": "The opening angle must be between 0 and {0}°.",
  "#OpeningPropsRecessRange": "The recess must be between 0 and the wall's thickness.",
  "#OpeningPropsSashDoesNotFit": "This sash type doesn't suit the selected opening.",
  "#OpeningSharedProject": "Opening shared project",
  "#Other": "Other",
  "#OtherAccountOpenVisit": "View only",
  "#OtherItem": "Other",
  "#OtherStyleName": "Transitional",
  "#PartitionsAndZoning": "Partitions and zoning",
  "#Perimeter": "Perimeter",
  "#PermissionsChanged": "Permissions changed",
  "#Photo": "Photo",
  "#PlanConstructionMoveToFreeSpot": "Move the opening to a free spot on a wall.",
  "#PlanConstructionNoFreeSpot": "There's no free spot on the wall for this opening.",
  "#PlanConstructionRoomTooSmall": "Make the room at least 20 cm wide and deep.",
  "#PlanExportArchitect": "Architectural floor plan",
  "#PlanExportArchitectDetail": "For interior design projects: a black-and-white plan with every wall's length.",
  "#PlanExportArchitectFile": "architectural",
  "#PlanExportClose": "Close plan export",
  "#PlanExportColour": "Full-color plan",
  "#PlanExportColourDetail": "Everything as on screen: floor colors, furniture, and dimensions if they are on.",
  "#PlanExportColourFile": "color",
  "#PlanExportDefaultName": "Plan",
  "#PlanExportDrawFailed": "Couldn't draw the plan. Try again.",
  "#PlanExportFurniture": "Floor plan with furniture",
  "#PlanExportFurnitureDetail": "A black-and-white plan for real estate listings: rooms and furniture layout.",
  "#PlanExportFurnitureFile": "with furniture",
  "#PlanExportNote": "{0}: the PNG image will be saved on this device.",
  "#PlanExportPreparing": "Preparing…",
  "#PlanExportSaveFailed": "Couldn't save the plan. Try again.",
  "#PlanGestureCopyIdTaken": "The copy's ID is already taken.",
  "#PlanScaleEnterArea": "Enter an area of at least 0.1 m².",
  "#PlanScaleEnterLength": "Enter a length of at least 0.1 m.",
  "#PlanScaleSizeUnusable": "This size can't be the basis for the scale.",
  "#PlanScaleTooFar": "This scale is too far from the plan.",
  "#PositionAndRotation": "Position & Rotation",
  "#ProjectWillRefreshOnReconnect": "The design will update itself once the connection is back",
  "#PromoteToEditor": "Promote to Editor",
  "#Properties": "Properties",
  "#PropertyEditMoldingNotFound": "Molding not found.",
  "#PropertyEditPlinthNotFound": "Plinth not found.",
  "#PropertyEditTrimHeightRange": "Height: enter a number from {0} to {1}.",
  "#PropsAppliedToFew": "Applied to {0} items",
  "#PropsAppliedToMany": "Applied to {0} items",
  "#PropsAppliedToOne": "Applied to {0} item",
  "#PropsArchOrOpening": "Arch / opening",
  "#PropsAttic": "Attic",
  "#PropsAtticHint": "Knee wall is the height where the slope starts; pitch is its angle to the floor.",
  "#PropsAtticNote": "Pitch {0}. The slope runs {1} m into the room and is {2} m long.",
  "#PropsAtticWindowInSlope": "The window lies in the slope: {0} m along it. With its bottom lower than {1} m from the floor, it stands in the wall and the slope above it opens into a niche.",
  "#PropsAtticWindowInWall": "The window stands in the wall, with a niche in the slope above it, like a dormer. With its bottom at {0} m from the floor or higher, it lies in the slope.",
  "#PropsBackSide": "Back side",
  "#PropsBackToParameters": "Back to properties",
  "#PropsCatalogModel": "Catalog model",
  "#PropsCeilingMolding": "Ceiling molding",
  "#PropsCenterAlongWall": "Center along wall",
  "#PropsCenterFromWallStart": "Center from wall start",
  "#PropsCheckSizes": "Check the sizes.",
  "#PropsChooseCurtainsInCatalog": "Choose curtains in the catalog",
  "#PropsChooseTypeBelow": "Choose a design type below",
  "#PropsCloseInspector": "Close item properties",
  "#PropsCoordinateX": "X coordinate",
  "#PropsCoordinateY": "Y coordinate",
  "#PropsCurrentFinish": "Current finish",
  "#PropsCurtainsDrapes": "Drapes",
  "#PropsCurtainsLabel": "Curtains: {0}. Choose curtains",
  "#PropsCurtainsRoller": "Roller blinds",
  "#PropsCurtainsSheer": "Sheers",
  "#PropsCustomDesign": "Custom design",
  "#PropsDeleteDoor": "Delete door",
  "#PropsDeleteWindow": "Delete window",
  "#PropsDistanceFromFloor": "Distance from floor",
  "#PropsDoorAngleNote": "To set the angle, choose a door type. The original model keeps its position.",
  "#PropsDoorDesign": "Door design",
  "#PropsDoorDouble": "Double door",
  "#PropsDoorFlush": "Flush",
  "#PropsDoorGlazed": "Glazed",
  "#PropsDrawnCurtains": "Simple editor curtains",
  "#PropsEditMaterial": "Edit material",
  "#PropsEndX": "End X",
  "#PropsEndY": "End Y",
  "#PropsEnterNumber": "{0}: enter a number from {1} to {2}.",
  "#PropsExactCoordinates": "Exact coordinates",
  "#PropsFromFloor": "From floor",
  "#PropsFromMeters": "from {0} m",
  "#PropsFrontSide": "Front side",
  "#PropsHingeOriginal": "Original",
  "#PropsHingeReversed": "Reversed",
  "#PropsHingeSide": "Hinge side",
  "#PropsItemActions": "Item actions",
  "#PropsItemProperties": "Item properties",
  "#PropsKnee": "Knee wall",
  "#PropsKneeFromFloor": "Knee wall, from floor",
  "#PropsLayWindowInSlope": "Lay the window in the slope",
  "#PropsModel": "Model",
  "#PropsModelNamed": "Model: {0}",
  "#PropsMoldingActions": "Molding actions",
  "#PropsMoldingHeightNote": "The height changes for all the room’s moldings, as in the app.",
  "#PropsNoModelChooseType": "No model — choose a type",
  "#PropsObjectMaterials": "Object materials",
  "#PropsOpenAngle": "Opening angle",
  "#PropsOpeningActions": "Opening actions",
  "#PropsOpeningReplacementNote": "Replacement: {0}. The opening’s size and position are kept.",
  "#PropsOpenModelCatalog": "Open the model catalog",
  "#PropsOriginalModel": "Original model",
  "#PropsPitch": "Pitch",
  "#PropsPlinthActions": "Plinth actions",
  "#PropsPlinthHeightNote": "The height changes for all the room’s plinths, as in the app.",
  "#PropsPositionInWall": "Position in wall",
  "#PropsProjectModel": "The project’s original model",
  "#PropsRecess": "Recess",
  "#PropsRecessNote": "Recess: from the inner face of the wall to the outer one.",
  "#PropsReplaceAllTitle": "Replace this and all the same items in this room",
  "#PropsReplaceFailed": "Couldn’t replace the items.",
  "#PropsReplacementNote": "Replacement: {0}. You can adjust the size before applying.",
  "#PropsReset": "Reset",
  "#PropsResetSection": "Reset: {0}",
  "#PropsRoom": "Room",
  "#PropsRoomSizeNote": "Measured on the floor, inside the walls, as in the app. Width and length move one side, area resizes the whole room, walls thicken outward, and the ceiling height applies to the whole level.",
  "#PropsRoomSurface": "Room surface",
  "#PropsRotation": "Rotation",
  "#PropsSliderLabel": "{0}, slider",
  "#PropsSlope": "Slope",
  "#PropsStartX": "Start X",
  "#PropsStartY": "Start Y",
  "#PropsSurfaceColor": "Surface color",
  "#PropsTextureAndColor": "Texture and color",
  "#PropsWallActions": "Wall actions",
  "#PropsWallEndCoordinates": "Wall end coordinates",
  "#PropsWallLengthNote": "Length changes from the start point. Adjoining walls move with the ends.",
  "#PropsWallSide": "Wall side",
  "#PropsWallsThicknessMixed": "Walls Thickness · currently varies",
  "#PropsWholeDoor": "Whole door",
  "#PropsWholeItem": "Whole item",
  "#PropsWholeOpening": "Whole opening",
  "#PropsWholeWindow": "Whole window",
  "#PropsWindowDesign": "Window design",
  "#PropsWindowDouble": "Double sash",
  "#PropsWindowSingle": "Single sash",
  "#PropsWindowTriple": "Triple sash",
  "#PurchaseRetryLoad": "Try again",
  "#Quality": "Quality",
  "#RecognitionAddFloor": "Add floor",
  "#RecognitionAnotherFloorDrop": "Another floor — drag it here or",
  "#RecognitionApartmentPlanName": "Apartment plan",
  "#RecognitionBadImageText": "The file seems to be damaged. Choose another image.",
  "#RecognitionBadImageTitle": "The image can't be read",
  "#RecognitionBusyText": "Lots of plans are being recognized right now. Try again in a minute.",
  "#RecognitionBusyTitle": "The recognition service is busy",
  "#RecognitionCancelledText": "Upload the plan again when you're ready.",
  "#RecognitionCancelledTitle": "Recognition stopped",
  "#RecognitionCheckAdvice": "Recognition can make mistakes: check the sizes and, if needed, fix the walls, windows, and doors.",
  "#RecognitionChooseFile": "Choose file",
  "#RecognitionChosenPlan": "Chosen plan",
  "#RecognitionCleaningImage": "refining the image",
  "#RecognitionDemoNote": "Demo: the recognition service is still being connected. A ready-made house will open instead of your plan.",
  "#RecognitionDrawWallsManually": "Draw walls by hand",
  "#RecognitionDropFormats": "JPG, PNG, WebP, or HEIC · one floor per image · up to {0}",
  "#RecognitionDropHere": "Drag a plan here",
  "#RecognitionElapsed": "Elapsed {0}",
  "#RecognitionFileTooLarge": "Larger than {0} MB",
  "#RecognitionFileUnreadable": "Couldn't read the image",
  "#RecognitionFileUnsupported": "Unsupported format — JPG or PNG needed",
  "#RecognitionFloorCountFew": "{0} floors",
  "#RecognitionFloorCountMany": "{0} floors",
  "#RecognitionFloorCountOne": "{0} floor",
  "#RecognitionFloorNotRecognized": "floor {0} — plan not recognized",
  "#RecognitionFloorNumber": "Floor {0}",
  "#RecognitionFloorOfFloors": "floor {0} of {1}",
  "#RecognitionFloorOrderLabel": "Floor order: top floor first",
  "#RecognitionFloorScaleNotMatched": "floor {0} — scale doesn't match the floor below",
  "#RecognitionFloorTimedOut": "floor {0} — recognition timed out",
  "#RecognitionHintDemo": "in the demo this takes about ten seconds",
  "#RecognitionHintLong": "a large plan or a lot of users — please wait a bit longer",
  "#RecognitionHintUsual": "usually under a minute; the project will open by itself",
  "#RecognitionHousePlanName": "House plan",
  "#RecognitionKeepWaiting": "Keep waiting",
  "#RecognitionLead": "A photo, scan, or screenshot of a plan — the walls, rooms, doors, and windows appear on their own, and the project opens in 3D.",
  "#RecognitionModelsProgress": "models {0} of {1}",
  "#RecognitionMoveFloorDown": "Floor {0}: move down",
  "#RecognitionMoveFloorUp": "Floor {0}: move up",
  "#RecognitionMyInterior": "My design",
  "#RecognitionNetworkText": "Check your internet connection or try again later.",
  "#RecognitionNetworkTitle": "No connection",
  "#RecognitionNoMoreFloors": "Can't upload more than {0}",
  "#RecognitionNotRecognizedText": "No walls that form rooms were found in the image. Try another image — straight, without glare, with the whole plan in the frame — or draw the walls by hand.",
  "#RecognitionNotRecognizedTitle": "Plan not recognized",
  "#RecognitionOverflow": "You can upload up to {0} plans at a time — the extra ones weren't added.",
  "#RecognitionPlan": "Plan",
  "#RecognitionProgressLabel": "Plan recognition",
  "#RecognitionQueuePosition": "in the queue, {0} ahead of you",
  "#RecognitionReadingImage": "Reading the image…",
  "#RecognitionReadingImages": "Reading images…",
  "#RecognitionRecognizeFloors": "Recognize {0}",
  "#RecognitionRecognizePlan": "Recognize plan",
  "#RecognitionRecognizingPlan": "Recognizing the plan",
  "#RecognitionRemoveFailed": "Remove the images that didn't open, or replace them.",
  "#RecognitionRemovePlan": "Remove {0}",
  "#RecognitionServerText": "The recognition service returned an error. Try again, and if that doesn't work, upload a different image.",
  "#RecognitionServerTitle": "Couldn't recognize the plan",
  "#RecognitionSizeKilobytes": "{0} KB",
  "#RecognitionSizeMegabytes": "{0} MB",
  "#RecognitionStartingSoon": "starting now",
  "#RecognitionStepActive": "— now",
  "#RecognitionStepAssembling": "Assembling the rooms",
  "#RecognitionStepDone": "— done",
  "#RecognitionStepOpening": "Opening in 3D",
  "#RecognitionStepRecognizing": "Recognizing walls, doors, and windows",
  "#RecognitionStepUploading": "Uploading the plan",
  "#RecognitionStopQuestion": "Stop recognition?",
  "#RecognitionStopWarning": "You'll have to upload the plan again.",
  "#RecognitionStorageText": "The browser didn't save the project: its storage is full. Delete projects you don't need and try again.",
  "#RecognitionStorageTitle": "Not enough space",
  "#RecognitionTakePhoto": "Take a photo",
  "#RecognitionTimedOutTitle": "Recognition timed out",
  "#RecognitionTipPhotoScanScreenshot": "A photo, scan, or screenshot will do",
  "#RecognitionTipRoomLabels": "Room labels give the rooms their names",
  "#RecognitionTipSharperImage": "The sharper the image, the more accurate the plan",
  "#RecognitionTipSizesDoorsWindows": "Sizes, doors, and windows on the plan help recognition",
  "#RecognitionTooLargeText": "Choose an image up to {0} MB.",
  "#RecognitionTooLargeTitle": "The image is too large",
  "#RecognitionTooManyText": "You can upload up to {0} plans at a time — one per floor.",
  "#RecognitionTooManyTitle": "Too many plans",
  "#RecognitionUnsupportedText": "Save the plan as a JPG or PNG image and upload it.",
  "#RecognitionUnsupportedTitle": "This format isn't supported",
  "#RemoveAccess": "Remove access",
  "#RemoveWall": "Remove wall",
  "#RenderResumeGaveUp": "The server didn't return the render within half an hour",
  "#RenderResumeNeverSent": "The render was never sent to the server",
  "#RoofLevelTitle": "Roof",
  "#RoomAll": "Room",
  "#RoomBabyKids": "Baby & Kids",
  "#RoomBabyKidsManyMy": "My Baby & Kid Rooms",
  "#RoomBath": "Bathroom",
  "#RoomBathManyMy": "My Bathrooms",
  "#RoomBedroom": "Bedroom",
  "#RoomBedroomManyMy": "My Bedrooms",
  "#RoomCafe": "Cafe & Bar",
  "#RoomCafeManyMy": "My Cafes & Bars",
  "#RoomCloset": "Closet",
  "#RoomClosetManyMy": "My Closets",
  "#RoomCoworking": "Office",
  "#RoomCoworkingManyMy": "My Offices",
  "#RoomDining": "Dining Room",
  "#RoomDiningManyMy": "My Dining Rooms",
  "#RoomEvent": "Event Hall",
  "#RoomEventManyMy": "My Event Halls",
  "#RoomFloorplan": "Floor Plan",
  "#RoomFloorplanManyMy": "My Floor Plans",
  "#RoomGarage": "Garage",
  "#RoomGarageManyMy": "My Garages",
  "#RoomGym": "Gym",
  "#RoomGymManyMy": "My Gyms",
  "#RoomHall": "Hallway",
  "#RoomHallManyMy": "My Hallways",
  "#RoomHomeCinema": "Home Cinema",
  "#RoomHomeCinemaManyMy": "My Home Cinemas",
  "#RoomHomeOffice": "Home Office",
  "#RoomHomeOfficeManyMy": "My Home Offices",
  "#RoomIsFullDesc": "This room has reached the maximum number of participants.",
  "#RoomIsFullTitle": "Room is full",
  "#RoomKitchen": "Kitchen",
  "#RoomKitchenManyMy": "My Kitchens",
  "#RoomLaundry": "Laundry",
  "#RoomLaundryManyMy": "My Laundries",
  "#RoomLiving": "Living Room",
  "#RoomLivingManyMy": "My Living Rooms",
  "#RoomName": "Room name",
  "#RoomOutdoor": "Yard or Patio",
  "#RoomOutdoorManyMy": "Yard or Patio",
  "#RoomReception": "Reception",
  "#RoomReceptionManyMy": "My Receptions",
  "#Rooms": "Rooms",
  "#RoomSalon": "Beauty Salon",
  "#RoomSalonManyMy": "My Beauty Salons",
  "#RoomShapeBayWindow2": "T-shape",
  "#RoomShapeCorner1": "L-shape",
  "#RoomShapeCorner2": "Cut",
  "#RoomShapeRectangular": "Rectangular",
  "#RoomShapesRounded": "Rounded",
  "#RoomShapeTitle": "Choose room shape",
  "#RoomShapeZshape": "Z-shape",
  "#RoomSizeAreaBlocked": "Couldn't change the room's area: neighboring walls are in the way.",
  "#RoomSizeAreaFailed": "Couldn't change the room's area.",
  "#RoomSizeAreaRange": "Area: from {0} to {1}.",
  "#RoomSizeCeilingHeightRange": "Ceiling height: from {0} to {1}.",
  "#RoomSizeLengthRange": "Length: from {0} to {1}.",
  "#RoomSizeNoArea": "The room has no area.",
  "#RoomSizeNoWalls": "The room has no walls.",
  "#RoomSizeOpeningDoesNotFitHeight": "The opening doesn't fit in a wall {0} m high.",
  "#RoomSizeRoomNotFound": "Room not found.",
  "#RoomSizeSideBlocked": "Couldn't change the room's size: neighboring walls are in the way.",
  "#RoomSizeThicknessFailed": "Couldn't change the wall thickness.",
  "#RoomSizeWallThicknessRange": "Wall thickness: from {0} to {1}.",
  "#RoomSizeWidthRange": "Width: from {0} to {1}.",
  "#RoomStore": "Store",
  "#RoomStoreManyMy": "My Stores",
  "#RoomType": "Room type",
  "#RoomTypeText": "Select room type",
  "#SearchByNameOrEmail": "Add people by name or email",
  "#SelectAll": "Select All",
  "#ShareCopyFailed": "Couldn't copy automatically. Link: {0}",
  "#ShareDemoNotice": "This is an example: agent bots are in the project. Click an avatar in the header to see the project through their eyes.",
  "#ShareRemoveBots": "Remove bots",
  "#ShareShowDemo": "Show an example with agent bots",
  "#ShareUnavailable": "Collaboration isn't available yet: the service is still being connected. You can keep editing the project in this browser.",
  "#ShareYou": "You",
  "#ShareYouMark": "(you)",
  "#SharingUpdateFailed": "Could not update sharing settings. Please try again.",
  "#ShoppingList": "Shopping list",
  "#ShowAllRooms": "Show all rooms",
  "#ShowMore": "More",
  "#ShowWall": "Show wall",
  "#SomethingWentWrong": "Something went wrong",
  "#SplitWall": "Split wall",
  "#StairsAndPodiums": "Stairs, podiums",
  "#Statistics": "Stats",
  "#StatisticsFinishCustomImage": "Custom image",
  "#StatisticsFinishSlope": "Slope",
  "#StatisticsRoomNameWithArea": "{0} ({1} m²)",
  "#StatsDialogAnsiCounted": "Per ANSI Z765: ceiling {0} m or higher",
  "#StatsDialogAnsiNotLiving": "Less than half above {0} m: not living area per ANSI Z765",
  "#StatsDialogAnsiTall": "Of it, ceiling {0} m or higher",
  "#StatsDialogCeilingSlopes": "Ceiling slopes",
  "#StatsDialogClose": "Close statistics",
  "#StatsDialogEmpty": "Draw a room — its dimensions, areas and materials will appear here.",
  "#StatsDialogFilter": "What to count",
  "#StatsDialogOfWhichSlopes": "Of which slopes",
  "#StatsDialogPrintProject": "project",
  "#StatsDialogPrintTitle": "Statistics — {0}",
  "#StatsDialogSummaryOf": "{0} — summary",
  "#StatsDialogValueCubicMeters": "{0} m³",
  "#StopFloorPlansImportButton": "Stop",
  "#StoreAccessClosed": "Access to the project is closed.",
  "#StoreAtticNotPossible": "This wall already has an attic, or it's shorter than a meter.",
  "#StoreCurtainsDoNotFit": "These curtains don't fit the opening.",
  "#StoreLocalSaveFailed": "Couldn't save the changes in the browser. Save again or export the project.",
  "#StoreNoProject": "No project is open.",
  "#StorePlanNotFound": "Floor plan not found.",
  "#StoreReplaceItemsFailed": "Couldn't replace the items.",
  "#StoreSharedBusy": "Checking the save. Wait for the connection before the next change.",
  "#StoreSharedConflict": "The action wasn't applied: the project has changed. Refresh the project and make the edit again.",
  "#StoreSharedInvalid": "The changes weren't saved. Check that the browser's storage is available and try again.",
  "#Summary": "Summary",
  "#SwitchTo2D": "2D plan",
  "#TagBalcony": "Balcony",
  "#TagPlinth": "Plinth",
  "#TagToilet": "Toilet",
  "#TextCopied": "Text copied",
  "#TextureScale": "Texture Scale",
  "#ThickerLabel": "Thicker",
  "#ThinnerLabel": "Thinner",
  "#ThisWeek": "This Week",
  "#TileSizeRange": "Enter a tile size from 1 cm to 20 m.",
  "#Today": "Today",
  "#ToolbarAddMoldings": "Add moldings",
  "#ToolbarAddOpening": "Add opening",
  "#ToolbarAddToCeiling": "Add to ceiling",
  "#ToolbarAddToWall": "Add to wall",
  "#ToolbarCeilingBeams": "Ceiling beams and structures",
  "#ToolbarCeilingFinish": "Ceiling finish",
  "#ToolbarCeilingLights": "Ceiling lights",
  "#ToolbarCloneRoom": "Clone room",
  "#ToolbarColorAndMaterial": "Color and material",
  "#ToolbarDeleteOpening": "Delete opening",
  "#ToolbarDeletePoint": "Delete point",
  "#ToolbarDeleteRoom": "Delete room",
  "#ToolbarDuplicateItem": "Duplicate item",
  "#ToolbarDuplicateOpening": "Duplicate opening",
  "#ToolbarFloorFinish": "Floor finish",
  "#ToolbarItem": "Item",
  "#ToolbarMoldingHeight": "Molding height",
  "#ToolbarMoreActions": "More actions",
  "#ToolbarMoreOpeningActions": "More opening actions",
  "#ToolbarMoreRoomActions": "More room actions",
  "#ToolbarMoreWallActions": "More wall actions",
  "#ToolbarOpening": "Opening",
  "#ToolbarOpeningInsteadOfWall": "Opening instead of wall",
  "#ToolbarOpeningSize": "Opening dimensions",
  "#ToolbarPlinthHeight": "Plinth height",
  "#ToolbarRemoveMolding": "Remove molding",
  "#ToolbarRemoveMoldings": "Remove moldings",
  "#ToolbarRemovePlinth": "Remove plinth",
  "#ToolbarRemovePlinths": "Remove plinths",
  "#ToolbarReplaceDoor": "Replace door",
  "#ToolbarReplaceItem": "Replace item",
  "#ToolbarReplaceWindow": "Replace window",
  "#ToolbarRoomSize": "Room dimensions",
  "#ToolbarRotateTexture": "Rotate texture 90°",
  "#ToolbarSizeWdh": "{0} × {1} × {2} m",
  "#ToolbarSizeWh": "{0} × {1} m",
  "#ToolbarSlopedCeiling": "Sloped ceiling",
  "#ToolbarSwingSide": "Swing side",
  "#ToolbarWallSideMaterial": "Wall side material",
  "#ToolbarWallSize": "Wall dimensions",
  "#ToolbarWindowView": "Window view",
  "#TryAgainButton": "Try again",
  "#UnitSquareMeters": "m²",
  "#UpgradeProPlusDescription": "Includes PRO features, plus 4K quality photos, unlimited rooms, commercial use, and enhanced design visibility",
  "#UpgradeProPlusPlusDescription": "All PRO+ benefits, with 360° photos, 3ds Max export, and top-tier design feed visibility",
  "#UpgradeToProPlusPlus": "Upgrade to PRO++",
  "#UploadFloorPlanGuidelineTip1": "One floor per image",
  "#UploadFloorPlanGuidelineTips": "Plan Tips",
  "#UploadPlan": "Upload plan",
  "#UserNameChangedToGuest": "{0} changed to Guest",
  "#UserNamePromotedToEditor": "{0} promoted to Editor",
  "#UserPermissions": "People with access",
  "#ValueCentimeters": "{0} cm",
  "#ValueMeters": "{0} m",
  "#ValueSquareMeters": "{0} m²",
  "#ViewFaceBack": "Back",
  "#ViewFaceBottom": "Bottom",
  "#ViewFaceFront": "Front",
  "#ViewFaceLeft": "Left end",
  "#ViewFaceRight": "Right end",
  "#ViewFaceSlope": "Slope",
  "#ViewFaceTop": "Top",
  "#ViewLoadCanceled": "Loading canceled",
  "#ViewLoadTimedOut": "Loading timed out",
  "#ViewModelCatalogEmpty": "The model catalog is empty or damaged",
  "#ViewModelCatalogHttpError": "Model catalog: HTTP {0}",
  "#ViewModelDefinitionHttpError": "Model description: HTTP {0}",
  "#ViewModelDefinitionNoItem": "The model description has no <Item>",
  "#ViewModelHttpError": "Model: HTTP {0}",
  "#ViewModelLoadTimedOut": "Model loading timed out",
  "#ViewModelNoDefinition": "The model has no description",
  "#ViewPlanAreaAnsi": "per ANSI {0} m²",
  "#ViewPlanSizeCentimeters": "{0} × {1} cm",
  "#ViewPlanSizeMeters": "{0} × {1} m",
  "#ViewPlanUnnamedRoom": "Room",
  "#Volume": "Volume",
  "#WallElevationPlan2DView": "Wall Elevation",
  "#WallLength": "Wall length",
  "#WallLengthBlocked": "Couldn't change the wall's length: neighboring walls are in the way.",
  "#WallLengthRange": "Wall length: from {0} to {1} m.",
  "#WallModeCutaway": "front ones cut away",
  "#WallModeFull": "full height",
  "#WallModeLow": "low",
  "#WallsWithOpenings": "Walls with openings",
  "#WallsWithoutOpenings": "Walls without openings",
  "#WebAskOwnerForRole": "Only the owner can let you edit: ask them for an invitation to edit.",
  "#WebAskToEdit": "Ask to edit",
  "#WebCanvasMenu": "Canvas menu",
  "#WebChatAddressedPublic": "Everyone in the project chat will see this message",
  "#WebCopySaved": "Copy saved: {0}",
  "#WebDeveloper": "Developer",
  "#WebDuplicate": "Duplicate",
  "#WebEditRequestFailed": "The request did not go. Try again.",
  "#WebEditRequestSent": "Request sent",
  "#WebExportOnServer": "This export is made on the server. It is coming soon.",
  "#WebExportPdf": "PDF",
  "#WebGestureChipDegrees": "{0}°",
  "#WebGoDownStairs": "Go down the stairs",
  "#WebGoUpStairs": "Go up the stairs",
  "#WebItemLocked": "The item is locked. Unlock it to move, turn, resize or delete it.",
  "#WebKeyboardShortcuts": "Keyboard shortcuts",
  "#WebLeaveWalk": "Leave the walk",
  "#WebLiveAcrossWall": "An item on a wall moves only along it.",
  "#WebLiveBadge": "Live",
  "#WebLiveCardGone": "The item wasn't added: its card is no longer in the list. Find it again and add it.",
  "#WebLiveChangedInApp": "Just replaced in the app: {0}. For now, an item replaced there can only be moved to another room or wall, copied or brought back in the app.",
  "#WebLiveConflict": "Another participant changed or deleted this item — the change was not applied.",
  "#WebLiveEditItemsDesc": "Shared project. You can move, rotate, add, delete and recolour items. Walls, rooms, openings and floors are changed in the app.",
  "#WebLiveEditWaits": "You can edit again once the connection is back.",
  "#WebLiveItemsOnly": "For now, walls, rooms, openings and floors can only be changed in the app.",
  "#WebLiveModelNotLoaded": "The model didn't load — try again",
  "#WebLiveNoId": "This object has no number in the file — it can only be changed in the app.",
  "#WebLiveNotConnected": "No connection to the project — the change was not sent.",
  "#WebLiveOnlyInApp": "This can only be changed in the app.",
  "#WebLiveOutsideFace": "Items are placed on the outer side of a wall in the app.",
  "#WebLivePaintInApp": "In a shared project, painting parts is only in the app for now. The model's colours are here.",
  "#WebLivePaintPartsInApp": "In a shared project, painting parts is only in the app for now.",
  "#WebLivePasteNeedsSource": "In the live room a copy is pasted only on the floor it was copied from, while the piece is unchanged. Copy it again.",
  "#WebLivePropsInApp": "In a shared project, size, height, mirroring and model replacement are changed in the app for now.",
  "#WebLiveSaveInAppFirst": "To edit here, save the project once in the app.",
  "#WebLiveSavedAutomatically": "Changes are saved automatically, about once a minute",
  "#WebLiveSavedByApp": "Some changes can't be written here, so only the app saves the project. The web will refresh its copy after the next save. If nobody in the project is using the app, edits will be lost when everyone leaves.",
  "#WebLiveSavedByAppShort": "Only the app saves the project",
  "#WebLiveSavedByAppRevision": "This project was saved by a different version of the app, so the web doesn't write it: only the app saves the project. If nobody in the project is using the app, edits will be lost when everyone leaves.",
  "#WebLiveWallRotateInApp": "Items on a wall are rotated in the app.",
  "#WebLockedStayedFew": "{0} locked items stayed in place",
  "#WebLockedStayedMany": "{0} locked items stayed in place",
  "#WebLockedStayedOne": "{0} locked item stayed in place",
  "#WebObjectMenu": "Object menu",
  "#WebParticipantActions": "Actions for {0}",
  "#WebParticipantClickForActions": "Click for actions",
  "#WebParticipantFollow": "Follow",
  "#WebParticipantJoins": "{0} joins",
  "#WebParticipantLeaves": "{0} leaves",
  "#WebParticipantMessage": "Message {0}",
  "#WebParticipantMessageTip": "Opens the project chat: everyone in it sees the message",
  "#WebParticipantOpenChat": "Open chat",
  "#WebParticipantRemoveText": "They will leave the project and can come back only if invited again.",
  "#WebParticipantRemoveTitle": "Remove access for {0}?",
  "#WebPasteHere": "Paste here",
  "#WebPresenceIn2D": "In 2D",
  "#WebPresenceInOrbit": "In orbit mode",
  "#WebPresenceInWalk": "In walkthrough",
  "#WebPresenceInWalls": "In walls view",
  "#WebPresenceInCeiling": "In ceiling view",
  "#WebPresenceInThisFile": "In this file",
  "#WebAgentOf": "{0}'s Agent",
  "#WebAgentColumnWidth": "Chat width",
  "#WebPaywallBuyInApp": "Plans can't be bought on the web yet: get {0} in the Home Planner app.",
  "#WebFollowLeftProject": "{0} left the project",
  "#WebShareAccessGone": "You no longer have access to this project.",
  "#WebShareAccessOf": "Access of {0}",
  "#WebShareAlreadyHasAccess": "{0} already has access",
  "#WebShareChangeFailed": "Couldn't save this change. Apply again.",
  "#WebShareCheckAddress": "Check the address",
  "#WebShareClearSearch": "Clear the search",
  "#WebShareInviteByEmail": "Invite by e-mail",
  "#WebShareInviteFailed": "Couldn't invite. Try again.",
  "#WebShareInviteFull": "Couldn't invite: this project has no room for more people.",
  "#WebShareInviteLimitOf": "Couldn't invite: this project holds up to {0} people.",
  "#WebShareInviteOwner": "That's the owner's address: the owner has access already.",
  "#WebShareInviteRole": "Role of the people you invite",
  "#WebShareLinkFailed": "Couldn't get the link. Try again in a moment.",
  "#WebShareLoadFailed": "Couldn't load who has access.",
  "#WebShareLocalNoLink": "Nobody else can open a project kept in this browser",
  "#WebShareNoMemberLink": "Only the owner can share the link to this project",
  "#WebShareNoResults": "Nobody found for «{0}»",
  "#WebShareSearchFailed": "Search isn't answering.",
  "#WebShareSignedOut": "Sign in again to see who has access.",
  "#WebShareVisitorsFew": "{0} visitors",
  "#WebShareVisitorsMany": "{0} visitors",
  "#WebShareVisitorsOne": "{0} visitor",
  "#WebTipMultiplayerTools": "Multiplayer tools",
  "#WebPresenceMoreInOtherViews": "{0} more in other views",
  "#WebPresenceShowEveryone": "Show everyone in the project",
  "#WebSaveCopy": "Save a copy",
  "#WebSessionOpenedElsewhere": "This project is open with your account in another tab or on another device. If you connect here, the project will close there.",
  "#WebShareApprove": "Approve",
  "#WebShareApproveRequest": "Approve the request of {0}",
  "#WebShareAsksToEdit": "Asks to edit",
  "#WebShareAsksToView": "Asks to view",
  "#WebShareDemoLeft": "{0} left the project",
  "#WebShareDemoOwner": "Project owner",
  "#WebShareDeny": "Deny",
  "#WebShareDenyRequest": "Deny the request of {0}",
  "#WebShareGuestDemoNotice": "This is an example: you see the project the way {0}, a guest, sees it. A request you send here reaches you as the owner.",
  "#WebShareRequestApprovedEdit": "{0} can edit now",
  "#WebShareRequestApprovedView": "{0} can view the project now",
  "#WebShareRequests": "Requests",
  "#WebShareRequestsWaiting": "Access requests are waiting",
  "#WebShareViewAsGuest": "View as a guest",
  "#WebShareViewAsOwner": "Back to the owner",
  "#WebShortcutOrbit": "Orbit",
  "#WebShortcutOrbitHow": "Right-drag",
  "#WebShortcutPan": "Pan",
  "#WebShortcutPanHow": "Space + drag or right-drag",
  "#WebShortcutPanSpace": "Space + drag",
  "#WebShortcutWalk": "Walk",
  "#WebShortcutWalkHow": "W A S D, arrows or scroll",
  "#WebShortcutZoom": "Zoom",
  "#WebShortcutZoomHow": "Scroll or pinch",
  "#WebShortcutsEdit": "Edit",
  "#WebShortcutsNavigation": "Navigation",
  "#WebShortcutsObjects": "Objects",
  "#WebTabCeilingView": "Ceiling view",
  "#WebTabWallsView": "Walls view",
  "#WebTipCatalog": "Open catalog",
  "#WebTipCeilingView": "Switch to ceiling view",
  "#WebTipCutaway": "Cutaway",
  "#WebTipDragToReorder": "Drag to reorder",
  "#WebTipFloorMap": "Open floor map",
  "#WebTipFloorOptions": "Floor options",
  "#WebTipFloorPlan": "Switch to floor plan",
  "#WebTipGallery": "Open gallery",
  "#WebTipMore": "More options",
  "#WebTipOpen2D": "Open 2D view",
  "#WebTipOpen3D": "Open 3D view",
  "#WebTipOpenAgent": "Open AI Agent",
  "#WebTipOrbit": "Switch to orbit",
  "#WebTipPhoto": "Create a photo render",
  "#WebTipWalk": "Switch to walkthrough",
  "#WebTipWallsDown": "Walls down",
  "#WebTipWallsUp": "Walls up",
  "#WebTipWallsView": "Switch to walls view",
  "#WebTipZoom": "Zoom options",
  "#WebUpgradeToPro": "Upgrade to PRO",
  "#WebUpgradeToProPlus": "Upgrade to PRO+",
  "#WebZoomIn": "Zoom in",
  "#WebZoomInOut": "Zoom in / out",
  "#WebZoomOut": "Zoom out",
  "#WebZoomPercent": "{0}%",
  "#WebZoomTo100": "Zoom to 100%",
  "#WebZoomToFit": "Zoom to fit",
  "#WindowSlopes": "Window Slopes",
  "#WindowSlopesNoSill": "Window Slopes (no sill)",
  "#WindowType": "Window Type",
  "#WindowViewBeach": "Beach",
  "#WindowViewCity": "City",
  "#WindowViewCityEvening": "City at dusk",
  "#WindowViewClose": "Close window view",
  "#WindowViewGarden": "Garden",
  "#WindowViewLoadFailed": "Couldn't load the view “{0}”.",
  "#WindowViewLoading": "Loading the view “{0}”…",
  "#WindowViewMeadow": "Meadow",
  "#WindowViewMountains": "Mountains",
  "#WindowViewNone": "No view",
  "#WindowViewNoneNote": "A plain background behind the windows.",
  "#WindowViewRotation": "View rotation",
  "#WindowViewSeaSunset": "Sunset by the sea",
  "#WindowViewSuburb": "Suburb",
  "#WindowViewSunNote": "The sun in the scene shines from the same side as in the panorama.",
  "#WindowViewTitle": "Window view",
  "#WindowViewTurnLeft": "Turn {0}° left",
  "#WindowViewTurnRight": "Turn {0}° right",
  "#WindowViewWinter": "Winter",
  "#Yesterday": "Yesterday",
  "#YourAccessChangedToEdit": "You can now edit this project",
  "#YourAccessChangedToView": "Your access has been changed to view-only",
  "#ZoomToRoom": "Zoom in",
  "Add": "Add",
  "Add Door": "Add Door",
  "Add Window": "Add Window",
  "All": "All",
  "Antique stain": "Antique stain",
  "Apply": "Apply",
  "Architectural": "Architectural",
  "Back": "Back",
  "Bathroom": "Bathroom",
  "Bedroom": "Bedroom",
  "Beech effect": "Beech effect",
  "Beech veneer": "Beech veneer",
  "Beige": "Beige",
  "Birch": "Birch",
  "Birch effect": "Birch effect",
  "Black": "Black",
  "Black brown": "Black brown",
  "Black steel": "Black steel",
  "Black-brown": "Black-brown",
  "Blue": "Blue",
  "Brightness": "Brightness",
  "Brown": "Brown",
  "Building": "Building",
  "Camera": "Camera",
  "Cancel": "Cancel",
  "Ceiling": "Ceiling",
  "Ceiling Moldings": "Ceiling Moldings",
  "Change Size": "Change Size",
  "Chats": "Chats",
  "Close": "Close",
  "Continue": "Continue",
  "Copy": "Copy",
  "DWG/DXF": "DWG/DXF",
  "Image": "Image",
  "Lock": "Lock",
  "Copied": "Copied",
  "Member": "Member",
  "Ok": "Ok",
  "Paste": "Paste",
  "Unlock": "Unlock",
  "cm": "cm",
  "Color": "Color",
  "Colors": "Colors",
  "Curtains": "Curtains",
  "Delete": "Delete",
  "Depth": "Depth",
  "Dimensions": "Dimensions",
  "Dining": "Dining",
  "Done": "Done",
  "Door": "Door",
  "Doors": "Doors",
  "Download": "Download",
  "Edit": "Edit",
  "Error": "Error",
  "Export": "Export",
  "Favorites": "Favorites",
  "Flip": "Flip",
  "Floor": "Floor",
  "Furniture": "Furniture",
  "Gallery": "Gallery",
  "Gloss gray": "Gloss gray",
  "Gloss red": "Gloss red",
  "Golden brown": "Golden brown",
  "Gray": "Gray",
  "Gray brown": "Gray brown",
  "Gray-brown": "Gray-brown",
  "Green": "Green",
  "Height": "Height",
  "High gloss black": "High gloss black",
  "High gloss gray": "High gloss gray",
  "High gloss red": "High gloss red",
  "High gloss white": "High gloss white",
  "Items": "Items",
  "Join": "Join",
  "Kitchen": "Kitchen",
  "Length": "Length",
  "Light brown": "Light brown",
  "Lighting": "Lighting",
  "m": "m",
  "Material": "Material",
  "Materials": "Materials",
  "Measure": "Measure with a ruler",
  "Medium brown": "Medium brown",
  "Molding": "Molding",
  "Move": "Move",
  "Multicolor": "Multicolor",
  "Natural": "Natural",
  "No": "No",
  "Oak": "Oak",
  "Open": "Open",
  "Openings": "Openings",
  "Other Rooms": "Other Rooms",
  "Owner": "Owner",
  "Pause": "Pause",
  "Pending": "Pending",
  "Pink": "Pink",
  "Plinths": "Plinths",
  "Position": "Position",
  "Reactions": "Reactions",
  "Recent": "Recent",
  "Red": "Red",
  "Redo": "Redo",
  "Rename": "Rename",
  "Replace": "Replace",
  "Reply": "Reply",
  "Restore": "Restore",
  "Retry": "Retry",
  "Room": "Room",
  "Rotate": "Rotate",
  "Saturation": "Saturation",
  "Save": "Save",
  "Select": "Select",
  "Send": "Send",
  "Settings": "Settings",
  "Share": "Share",
  "Share project": "Share project",
  "Sign in": "Sign in",
  "Sign out": "Sign out",
  "subscriptionDescription": "Accurate measurements, full catalog, unlimited photos, custom materials. Up to 15 designs",
  "Texture": "Texture",
  "Thickness": "Thickness",
  "Title": "Title",
  "Tools": "Tools",
  "Transparency": "Transparency",
  "Undo": "Undo",
  "Wabi-sabi": "Wabi-sabi",
  "Wall": "Wall",
  "Walls": "Walls",
  "Walls Thickness": "Walls Thickness",
  "White": "White",
  "White stain": "White stain",
  "Width": "Width",
  "Window": "Window",
  "Windows": "Windows",
  "Yellow": "Yellow"
}
